var _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M77.66,245.29c-95.18,55-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,190.34,77.66,245.29Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.07,343.52a8.26,8.26,0,0,0-7.78-4.08c-4.28.2-8.32,2.38-8.45,2.87s3.26,3.55,8.26,3.94A9.61,9.61,0,0,0,36.07,343.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.57,349.92a8.21,8.21,0,0,0-8.78-.08c-3.72,2.13-6.32,5.91-6.22,6.41s4.52,1.66,9.15-.27A9.64,9.64,0,0,0,44.57,349.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.55,345.66A8.24,8.24,0,0,0,50.11,337c-2.74-3.29-6.45-5.26-6.93-5.07s-1,5.23,1.18,9.19C46.72,345.42,50.35,345.36,51.55,345.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,369.16c-1.83-3.39-4.75-6.16-7.6-8.69a64.94,64.94,0,0,0-8.62-6.42,84.37,84.37,0,0,0-20.35-9.25c-4.54-1.36-9.43-2.63-14.2-2.46-.1,0-.15.25-.05.27a66.35,66.35,0,0,1,12.69,3.16A78.4,78.4,0,0,1,52.18,350a81.23,81.23,0,0,1,16.71,10.75A111.68,111.68,0,0,1,78.22,370,.72.72,0,0,0,79.4,369.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,348.72a25.49,25.49,0,0,0-2.16-5.4,14.73,14.73,0,0,0-3.32-4.45c-.2-.17-.12.22,0,.35a42.9,42.9,0,0,1,2.41,4.35,18.54,18.54,0,0,1,1.56,5,1.17,1.17,0,0,0,1,.93A.61.61,0,0,0,53.2,348.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.49,348.57a21.3,21.3,0,0,0-8.06.69,24.69,24.69,0,0,0-3.55,1.1,14.78,14.78,0,0,0-3.83,2.16s-.21.36-.11.31a39.68,39.68,0,0,1,4-1.61,23.09,23.09,0,0,1,3.79-1,35.77,35.77,0,0,1,7.79-.59C53.07,349.67,53,348.64,52.49,348.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88,356.78a8.24,8.24,0,0,0-8.57-1.91c-4.08,1.31-7.41,4.47-7.41,5s4.07,2.57,9,1.64A9.6,9.6,0,0,0,58.88,356.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,357.12a21.13,21.13,0,0,0-8-1,23,23,0,0,0-3.7.33A14.49,14.49,0,0,0,51,357.76c-.05,0-.28.31-.17.28a40.15,40.15,0,0,1,4.24-.74,22.26,22.26,0,0,1,3.91-.16,34.9,34.9,0,0,1,7.74,1C67.25,358.31,67.36,357.28,66.91,357.12Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.11,310a9.05,9.05,0,0,1-2.93-9.19c1-4.58,4.15-8.54,4.71-8.59s3.21,4.2,2.68,9.68A10.61,10.61,0,0,1,51.11,310Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41,320.35A9,9,0,0,1,58,310.84c3-3.61,7.59-5.7,8.11-5.5s.94,5.2-2,9.84A10.57,10.57,0,0,1,56.41,320.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.48,327.08a9,9,0,0,1-9.09-3.2c-3-3.59-4.47-8-4.17-8.45s5.84-.07,9.7,3C51.13,321.81,50.38,325.73,50.48,327.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,361.65c-3.31-2.63-5.75-6.3-8-9.87a71.18,71.18,0,0,1-5.3-10.54,92.38,92.38,0,0,1-6.13-23.75c-.61-5.16-1.05-10.69,0-15.81,0-.11.3-.12.3,0a72.64,72.64,0,0,0,1,14.31A86.46,86.46,0,0,0,55,328.59a89,89,0,0,0,8.44,20.1c2.38,4.22,5.4,7.95,8.24,11.85A.79.79,0,0,1,70.59,361.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.47,329.45A28.44,28.44,0,0,1,48,326.08a16.14,16.14,0,0,1-4.17-4.43c-.14-.25.26-.08.39,0a43.81,43.81,0,0,0,4.24,3.43,20.7,20.7,0,0,0,5.14,2.65,1.26,1.26,0,0,1,.83,1.21A.67.67,0,0,1,53.47,329.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.45,328.66c.1-3,.94-5.36,2.28-8.59a24.74,24.74,0,0,1,1.86-3.62,15.84,15.84,0,0,1,3.06-3.73c.05,0,.43-.16.36-.06a39.72,39.72,0,0,0-2.5,4,24.45,24.45,0,0,0-1.78,3.92,38.55,38.55,0,0,0-2.12,8.3C54.52,329.49,53.43,329.17,53.45,328.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.11,337.12a9,9,0,0,1-.44-9.63c2.19-4.16,6.23-7.16,6.79-7.07s2,4.9.06,10.05A10.55,10.55,0,0,1,61.11,337.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,345.87c-.53-2.95-.2-5.44.44-8.88a26.83,26.83,0,0,1,1.06-3.93,16,16,0,0,1,2.21-4.28c.05,0,.39-.25.34-.14a42.9,42.9,0,0,0-1.6,4.45,23.39,23.39,0,0,0-.92,4.2,38.8,38.8,0,0,0-.35,8.56C61.17,346.45,60,346.37,60,345.87Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451,363.94a8.23,8.23,0,0,1,5-7.22c3.88-1.81,8.47-1.76,8.82-1.38s-1.25,4.65-5.5,7.32A9.65,9.65,0,0,1,451,363.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.46,373.55a8.23,8.23,0,0,1,7.74-4.15c4.28.16,8.34,2.31,8.48,2.8s-3.23,3.57-8.23,4A9.58,9.58,0,0,1,446.46,373.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.3,373a8.22,8.22,0,0,1-2.74-8.34c.9-4.19,3.27-7.65,3.78-7.71s3.29,4.18,3.21,8.69C442.47,370.56,439.22,372.19,438.3,373Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.53,406.76c.06-3.86,1.35-7.66,2.71-11.23a64.83,64.83,0,0,1,4.65-9.69,84.13,84.13,0,0,1,13.74-17.63c3.39-3.31,7.13-6.7,11.43-8.77.1,0,.25.16.17.22a67.16,67.16,0,0,0-9.78,8.68,79.48,79.48,0,0,0-7.7,8.81,81,81,0,0,0-9.82,17.27A113.92,113.92,0,0,0,426,407,.72.72,0,0,1,424.53,406.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.25,376.49a26.22,26.22,0,0,1-.58-5.79,14.79,14.79,0,0,1,.87-5.48c.1-.24.21.14.19.3a43.53,43.53,0,0,0-.12,5,19.09,19.09,0,0,0,.95,5.18,1.14,1.14,0,0,1-.41,1.27A.61.61,0,0,1,438.25,376.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.81,376a21.3,21.3,0,0,1,7.47-3.12,23.93,23.93,0,0,1,3.65-.68,14.65,14.65,0,0,1,4.39.14c.06,0,.36.22.25.22a38.7,38.7,0,0,0-4.29.43,23.54,23.54,0,0,0-3.81.89,35.42,35.42,0,0,0-7.18,3.09C438.81,377.27,438.43,376.31,438.81,376Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,386.27a8.25,8.25,0,0,1,6.71-5.67c4.22-.73,8.64.52,8.88,1s-2.42,4.17-7.22,5.63A9.64,9.64,0,0,1,437,386.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,390.29a21.29,21.29,0,0,1,6.64-4.61,23.48,23.48,0,0,1,3.44-1.42,14.61,14.61,0,0,1,4.32-.79c.06,0,.39.15.28.17a38.08,38.08,0,0,0-4.1,1.32,22.08,22.08,0,0,0-3.54,1.67,34.68,34.68,0,0,0-6.37,4.51C430.27,391.51,429.69,390.64,430,390.29Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M90.75,343.81c-44.52,25.7-44.52,67.38,0,93.09s116.71,25.7,161.24,0,44.52-67.39,0-93.09S135.27,318.1,90.75,343.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M322.93,370.36c-24.79,14.31-24.79,37.51,0,51.82s65,14.31,89.75,0,24.78-37.51,0-51.82S347.71,356.05,322.93,370.36Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Jar--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.73,187c0-12.78-8.53-25.57-25.59-35.31-34.11-19.51-89.43-19.51-123.54,0-16,9.14-24.49,20.94-25.49,32.91-.07.8-.1,1.6-.1,2.4v11a26.28,26.28,0,0,0,.1,2.66c1,12,9.5,23.77,25.49,32.91,34.11,19.51,89.43,19.51,123.54,0,17.06-9.75,25.59-22.53,25.59-35.31Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,174.08c0-13.11-8.75-26.23-26.25-36.24-35-20-91.79-20-126.8,0-16.4,9.39-25.13,21.5-26.15,33.78-.07.82-.11,1.64-.11,2.46s0,10.56,0,11.29c0,.91,0,1.82.11,2.73,1,12.29,9.75,24.39,26.15,33.78,35,20,91.79,20,126.8,0,17.5-10,26.25-23.13,26.25-36.24Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,187c0-12.78-8.53-25.57-25.59-35.31-34.11-19.51-89.43-19.51-123.54,0-16,9.14-24.49,20.94-25.49,32.91-.07.8-.1,1.6-.1,2.4v11a26.28,26.28,0,0,0,.1,2.66c1,12,9.5,23.77,25.49,32.91,34.11,19.51,89.43,19.51,123.54,0,17.06-9.75,25.59-22.53,25.59-35.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,212.54l0-.13c-1.8-12.78-11.23-25.28-28.33-35-38.25-21.86-100.26-21.86-138.5,0-17.75,10.16-27.26,23.23-28.52,36.51,0,0,0,0,0,.07a31.63,31.63,0,0,0-.51,5.73V384.23c0,14.54,9.61,29.07,28.8,40.15,38.41,22.17,100.67,22.17,139.08,0,19.21-11.08,28.81-25.61,28.81-40.15V219.69A33.32,33.32,0,0,0,270,212.54Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,212.54l0-.13c-1.8-12.78-11.23-25.28-28.33-35-38.25-21.86-100.26-21.86-138.5,0-17.75,10.16-27.26,23.23-28.52,36.51,0,0,0,0,0,.07a31.63,31.63,0,0,0-.51,5.73V384.23c0,14.54,9.61,29.07,28.8,40.15,38.41,22.17,100.67,22.17,139.08,0,19.21-11.08,28.81-25.61,28.81-40.15V219.69A33.32,33.32,0,0,0,270,212.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.86,219.68V371c0,13.27-8.86,26.55-26.58,36.67-35.42,20.26-92.88,20.26-128.31,0-16.6-9.5-25.43-21.74-26.47-34.18V219.68c0-12.3,8.87-24.2,25-33.51a95.18,95.18,0,0,1,12.32-5.92c5.87-2.34,29.59-9.49,53.33-9.49s47.56,7.15,53.43,9.49a95.18,95.18,0,0,1,12.32,5.92C254,195.48,262.86,207.38,262.86,219.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,371c0,13.27-8.86,26.55-26.58,36.67-35.42,20.26-92.88,20.26-128.31,0-16.6-9.5-25.43-21.74-26.47-34.18a29.58,29.58,0,0,1,0-5c1-12.42,9.87-24.68,26.47-34.18,35.43-20.26,92.89-20.26,128.31,0C254.24,344.43,263.1,357.71,263.1,371Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,187c0-12.78-8.53-25.57-25.59-35.31-34.11-19.51-89.43-19.51-123.54,0-16,9.14-24.49,20.94-25.49,32.91-.07.8-.1,1.6-.1,2.4v11a26.28,26.28,0,0,0,.1,2.66c1,12,9.5,23.77,25.49,32.91,34.11,19.51,89.43,19.51,123.54,0,17.06-9.75,25.59-22.53,25.59-35.31Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,187c0,12.77-8.53,25.56-25.59,35.3-34.11,19.51-89.43,19.51-123.54,0-16-9.14-24.49-20.93-25.49-32.9a27.48,27.48,0,0,1,0-4.8c1-12,9.5-23.77,25.49-32.91,34.11-19.51,89.43-19.51,123.54,0C251.2,161.4,259.73,174.19,259.73,187Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.74,187c0,11.22-7.75,22.47-23.24,31-31,17.15-81.26,17.15-112.26,0-14.52-8-22.25-18.4-23.15-28.92a22.88,22.88,0,0,1,0-4.22c.9-10.52,8.63-20.89,23.15-28.93,31-17.15,81.26-17.15,112.26,0C244,164.5,251.74,175.74,251.74,187Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,173.05c-31-17.14-81.26-17.14-112.26,0-11.53,6.39-18.76,14.25-21.71,22.48,3,8.24,10.18,16.09,21.71,22.47,31,17.15,81.26,17.15,112.26,0,11.53-6.38,18.77-14.24,21.72-22.47C247.27,187.29,240,179.43,228.5,173.05Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,174.08c0-13.11-8.75-26.23-26.25-36.24-35-20-91.79-20-126.8,0-16.4,9.39-25.13,21.5-26.15,33.78-.07.82-.11,1.64-.11,2.46s0,10.56,0,11.29c0,.91,0,1.82.11,2.73,1,12.29,9.75,24.39,26.15,33.78,35,20,91.79,20,126.8,0,17.5-10,26.25-23.13,26.25-36.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,165.85c0-13.11-8.75-26.23-26.25-36.24-35-20-91.79-20-126.8,0-16.4,9.39-25.13,21.5-26.15,33.78-.07.82-.11,1.64-.11,2.46s0,18.79,0,19.52c0,.91,0,1.82.11,2.73,1,12.29,9.75,24.39,26.15,33.78,35,20,91.79,20,126.8,0,17.5-10,26.25-23.13,26.25-36.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.92,236.6l2.45.12V169.2h-2.45Zm-27.39-4.23L138,233V169.2h-2.45Zm32.87,4.47,2.45,0V169.2H168.4ZM141,233.65c.81.17,1.63.35,2.45.51v-65H141Zm5.48,1.06c.81.14,1.63.27,2.45.39V169.2h-2.45Zm10.95,1.45,2.45.23V169.2h-2.45Zm-5.47-.62,2.45.31V169.2H152Zm-21.91-4.71c.81.25,1.63.48,2.45.71V169.2h-2.45ZM91.71,208c.77.9,1.59,1.79,2.45,2.67V169.2H91.71Zm11,9.82c.79.56,1.61,1.11,2.45,1.65V169.2h-2.45Zm-5.48-4.31c.78.69,1.6,1.37,2.45,2V169.2H97.19Zm-11-13.68a40.12,40.12,0,0,0,2.46,4.19V169.2H86.23ZM124.58,229c.81.29,1.62.59,2.45.86V169.2h-2.45Zm-5.48-2.14c.81.35,1.63.67,2.45,1V169.2H119.1Zm-5.48-2.53c.81.41,1.62.81,2.45,1.19V169.2h-2.45Zm-5.48-3,.83.5c.53.3,1.09.58,1.63.88V169.2h-2.46Zm98.6,11.6,2.45-.61V169.2h-2.45Zm32.87-13.46c.83-.54,1.66-1.08,2.45-1.64V169.2h-2.45Zm-65.73,17.35,2.45,0V169.2h-2.45Zm49.29-9c.83-.33,1.65-.65,2.46-1V169.2h-2.46Zm5.48-2.33c.83-.38,1.64-.79,2.45-1.19V169.2h-2.45ZM256,169.2V204a39.51,39.51,0,0,0,2.45-4.15V169.2Zm-11,46.42q1.28-1,2.46-2V169.2h-2.46Zm5.48-4.91c.87-.89,1.69-1.78,2.45-2.68V169.2h-2.45Zm-16.43,12.06,1.64-.89.81-.49V169.2h-2.45Zm-49.3,13.62c.82-.06,1.64-.15,2.45-.22v-67h-2.45Zm-5.48.33q1.23,0,2.46-.12V169.2h-2.46Zm11-.87,2.45-.31V169.2h-2.45Zm10.95-1.69c.83-.16,1.64-.33,2.46-.51V169.2h-2.46Zm11-2.61c.82-.24,1.64-.47,2.45-.72V169.2h-2.45Zm5.48-1.68c.82-.28,1.63-.58,2.45-.87V169.2H217.7Zm-21.91,5.23c.81-.12,1.63-.24,2.45-.38V169.2h-2.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,165.85c0,13.11-8.75,26.23-26.25,36.23-35,20-91.79,20-126.8,0-16.4-9.38-25.13-21.48-26.15-33.77a28.87,28.87,0,0,1,0-4.92c1-12.28,9.75-24.39,26.15-33.78,35-20,91.79-20,126.8,0C253.27,139.62,262,152.74,262,165.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.13 190.66 130.07 149.79 145.61 141.04 214.67 181.91 199.13 190.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.61 141.04 145.51 149.95 206.9 186.28 214.67 181.91 145.61 141.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.61 141.04 212.77 182.04 206.9 186.28 214.67 181.91 145.61 141.04",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.61 141.04 145.51 149.95 137.74 154.33 130.07 149.79 145.61 141.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.13 190.66 130.07 149.79 145.61 141.04 129.15 149.83 199.13 190.66",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M235.12,354c-17.45-10.07-43.43-12.19-64.48-6.38-21.06-5.81-47-3.69-64.48,6.38-22.12,12.77-22.12,33.47,0,46.24,17.44,10.07,43.42,12.19,64.48,6.38,21.05,5.81,47,3.69,64.48-6.38C257.23,387.47,257.23,366.77,235.12,354Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.31,365.19c2.46-4.14,6.54-8,12.26-11.34,20.05-11.57,52.54-11.57,72.59,0,5.72,3.31,9.8,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-20,11.57-52.55,11.57-72.59,0-9.64-5.56-14.66-12.79-15-20.08h0V365.19Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.31,365.19c2.46-4.14,6.54-8,12.26-11.34,20.05-11.57,52.54-11.57,72.59,0,5.72,3.31,9.8,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-20,11.57-52.55,11.57-72.59,0-9.64-5.56-14.66-12.79-15-20.08h0V365.19Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.86,345.18c13.14,0,26.27,2.89,36.3,8.67,5.72,3.31,9.8,7.2,12.25,11.34h2.78v10.49h0c-.37,7.29-5.36,14.52-15,20.08-10,5.79-23.16,8.68-36.3,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89,350a56,56,0,0,1,8.27,3.86c5.72,3.31,9.8,7.2,12.25,11.34h2.78v10.49h0c-.37,7.29-5.36,14.52-15,20.08a56,56,0,0,1-8.27,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83,350a56.35,56.35,0,0,0-8.26,3.86c-5.72,3.31-9.8,7.2-12.26,11.34H93.54v10.49h0c.37,7.29,5.39,14.52,15,20.08a56.39,56.39,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,344.24c20,11.58,20,30.34,0,41.91-17.54,10.12-44.61,11.39-64.53,3.8h0l-.79-.31a56.58,56.58,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.33-35.61h0a39.22,39.22,0,0,1,8.32-6.29C128.61,332.67,161.11,332.67,181.16,344.24Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,344.24c20,11.58,20,30.34,0,41.91-17.54,10.12-44.61,11.39-64.53,3.8h0l-.79-.31a56.58,56.58,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.33-35.61h0a39.22,39.22,0,0,1,8.32-6.29C128.61,332.67,161.11,332.67,181.16,344.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24,350.54c-.21.24-7.22,7.64-5.36,18.28,1.77,10.19,16,18.76,21,20.82a56.58,56.58,0,0,1-7.26-3.49C91.86,376.5,89.08,361.85,100.24,350.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.48,379.85c.22-.24,7.23-7.63,5.37-18.28-1.78-10.18-16-18.75-20.95-20.81a55.11,55.11,0,0,1,7.25,3.48C197.87,353.89,200.65,368.54,189.48,379.85Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.88,
    cy: 365.16,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.88,
    cy: 365.16,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,373.38c3.84-7.09,2.59-14.9-3.74-21.53a32.27,32.27,0,0,0-4-3.54,39.86,39.86,0,0,0-3.87-2.54c-.76-.45-1.54-.87-2.35-1.28,2,3.27,1.26,6.76-10,7.42-22,1.28,5.88,22.3,5.88,22.3S186.5,367.36,190.42,373.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.16,367.57c3.3-.37,4.93-3.76,3.65-7.58s-5-6.61-8.3-6.24-4.93,3.76-3.65,7.58S184.86,367.94,188.16,367.57Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.37,385.08c-1.08-8.16-36.77-30.77-36.77-30.77s-7.92-3.18-5.29-8.71a41.22,41.22,0,0,0-3.82,2.47c-.82.59-1.6,1.21-2.32,1.84-10.63,9.2-10.64,21.28,0,30.5.71.62,1.49,1.24,2.31,1.84,1.1.79,2.27,1.56,3.54,2.3s2.48,1.37,3.78,2c1,.49,2.12,1,3.22,1.38s2.21.84,3.34,1.21A70.42,70.42,0,0,0,132,391.68c.8.13,1.6.24,2.4.35a83.78,83.78,0,0,0,10.65.67,81.5,81.5,0,0,0,13-1.07S152.35,390.45,153.37,385.08Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.37,385.08c-1.08-8.16-36.77-30.77-36.77-30.77s-7.92-3.18-5.29-8.71a41.22,41.22,0,0,0-3.82,2.47c-.82.59-1.6,1.21-2.32,1.84-10.63,9.2-10.64,21.28,0,30.5.71.62,1.49,1.24,2.31,1.84,1.1.79,2.27,1.56,3.54,2.3s2.48,1.37,3.78,2c1,.49,2.12,1,3.22,1.38s2.21.84,3.34,1.21A70.42,70.42,0,0,0,132,391.68c.8.13,1.6.24,2.4.35a83.78,83.78,0,0,0,10.65.67,81.5,81.5,0,0,0,13-1.07S152.35,390.45,153.37,385.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,350.64c-13.31,7.69-13.85,20-1.62,28,.52.34,1.06.68,1.63,1,13.88,8,36.38,8,50.26,0s13.88-21,0-29c-.56-.32-1.15-.64-1.74-.94C154.29,342.64,133.05,343,119.73,350.64Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,350.64c-13.31,7.69-13.85,20-1.62,28,.52.34,1.06.68,1.63,1,13.88,8,36.38,8,50.26,0s13.88-21,0-29c-.56-.32-1.15-.64-1.74-.94C154.29,342.64,133.05,343,119.73,350.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.88,
    cy: 365.15,
    rx: 33.98,
    ry: 19.62,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.88,
    cy: 365.15,
    rx: 33.98,
    ry: 19.62,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86,356.76c13.27-7.66,34.78-7.66,48.05,0,5.42,3.13,8.63,7.06,9.62,11.13-1,4.07-4.2,8-9.62,11.13-13.27,7.67-34.78,7.67-48,0-5.43-3.13-8.63-7.06-9.62-11.13C112.23,363.82,115.43,359.89,120.86,356.76Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86,356.76c13.27-7.66,34.78-7.66,48.05,0,5.42,3.13,8.63,7.06,9.62,11.13-1,4.07-4.2,8-9.62,11.13-13.27,7.67-34.78,7.67-48,0-5.43-3.13-8.63-7.06-9.62-11.13C112.23,363.82,115.43,359.89,120.86,356.76Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,371.06c0-.66,0-3.36,0-4.05,0-1.66-1.15-3.28-3.63-4.73l-.08,0c-4.56-2.63-9.28-2.29-13.48-1.23h0c-1.79.45-3.48,1-5,1.56a47.61,47.61,0,0,1-5.4,1.67h0a9.44,9.44,0,0,1-2.56.24,5.48,5.48,0,0,1-2.13-.56l.17-.12.53-.33a11.77,11.77,0,0,1,1.43-.7,9.86,9.86,0,0,1,7.55-.18L148,358.2v-4a20.73,20.73,0,0,0-11.91-.44,26.6,26.6,0,0,0-3.79,1.31l-4.36-2.51-5.19,3v4l1.78,1a4.34,4.34,0,0,0-.77,2.35c0,.67,0,3.35,0,4,0,1.66,1.19,3.27,3.7,4.72a15.09,15.09,0,0,0,7.18,2.06h0q.72,0,1.44,0a28.46,28.46,0,0,0,7.71-1.67c.51-.17,1-.34,1.5-.52l-4.39,4.4v4a21.38,21.38,0,0,0,16.8-.72l4.3,2.48,5.2-3v-4l-1.78-1A4.72,4.72,0,0,0,166.28,371.06Zm-11-.34a11.22,11.22,0,0,1-9.7.73c4.07-1.44,7.47-2.7,10.36-1.15Q155.67,370.51,155.31,370.72Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.09,361h0c-1.79.45-3.48,1-5,1.56a47.61,47.61,0,0,1-5.4,1.67h0a9.44,9.44,0,0,1-2.56.24,5.41,5.41,0,0,1-2.48-.74c-1.67-1-1.91-2.38.52-4l.53-.33a13.56,13.56,0,0,1,1.43-.71,9.86,9.86,0,0,1,7.55-.17l4.36-4.39a20.73,20.73,0,0,0-11.91-.44,26.6,26.6,0,0,0-3.79,1.31l-4.36-2.51-5.19,3L127,358l0,0c-4.37,3.32-4.46,6.77.46,9.61a15.21,15.21,0,0,0,7.18,2.06h0c.48,0,1,0,1.44,0a28.45,28.45,0,0,0,7.71-1.66c5-1.67,9-3.63,12.39-1.7,2.25,1.31,1.63,2.94-.85,4.37a11.2,11.2,0,0,1-9.86.66L140.88,376a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3-4.3-2.49c4.33-3.34,4.82-7-.23-10l-.08,0C158,359.6,153.29,359.94,149.09,361Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.09,361h0c-1.79.45-3.48,1-5,1.56a47.61,47.61,0,0,1-5.4,1.67h0a9.44,9.44,0,0,1-2.56.24,5.41,5.41,0,0,1-2.48-.74c-1.67-1-1.91-2.38.52-4l.53-.33a13.56,13.56,0,0,1,1.43-.71,9.86,9.86,0,0,1,7.55-.17l4.36-4.39a20.73,20.73,0,0,0-11.91-.44,26.6,26.6,0,0,0-3.79,1.31l-4.36-2.51-5.19,3L127,358l0,0c-4.37,3.32-4.46,6.77.46,9.61a15.21,15.21,0,0,0,7.18,2.06h0c.48,0,1,0,1.44,0a28.45,28.45,0,0,0,7.71-1.66c5-1.67,9-3.63,12.39-1.7,2.25,1.31,1.63,2.94-.85,4.37a11.2,11.2,0,0,1-9.86.66L140.88,376a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3-4.3-2.49c4.33-3.34,4.82-7-.23-10l-.08,0C158,359.6,153.29,359.94,149.09,361Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "122.72 355.53 127.97 353.15 132.27 355.05 127.92 352.53 122.72 355.53",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.45,353.9a24.26,24.26,0,0,1,11.18.38l-3,4.28,4.36-4.39A20.76,20.76,0,0,0,135.45,353.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.57,362.23l.08,0c5,3,4.56,6.61.23,10,3.83-4.17,3.14-7.08-1-9.49s-9.47-2.37-12.77-1.74C153.29,359.94,158,359.6,162.57,362.23Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.88 372.23 166.18 374.77 161.99 377.72 167.18 374.71 162.88 372.23",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11,371.32a11.15,11.15,0,0,1-8.29.72L140.88,376l4.57-4.58A11.17,11.17,0,0,0,154.11,371.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.62,364.24c-2,.77-4.79.64-6.22-.59s-.54-2.68,1.7-3.88c-2.43,1.59-2.19,3-.52,4a5.41,5.41,0,0,0,2.48.74A9.44,9.44,0,0,0,138.62,364.24Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,358.05c-.37.33-3.5,3.25-2.11,6.16,1.46,3.11,6,5.11,9.75,5.51h0a15.21,15.21,0,0,1-7.18-2.06C122.52,364.82,122.61,361.37,127,358.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.66,347.48c2.45-4.14,6.53-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.72,3.31,9.81,7.2,12.26,11.34h2.77V358h0c-.37,7.29-5.36,14.51-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.57-14.67-12.79-15-20.08h0V347.48Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.66,347.48c2.45-4.14,6.53-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.72,3.31,9.81,7.2,12.26,11.34h2.77V358h0c-.37,7.29-5.36,14.51-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.57-14.67-12.79-15-20.08h0V347.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,327.46c13.13,0,26.27,2.9,36.29,8.68,5.73,3.31,9.81,7.2,12.26,11.34h2.77V358h0c-.37,7.29-5.36,14.51-15,20.08-10,5.79-23.16,8.68-36.29,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,332.27a56.94,56.94,0,0,1,8.26,3.87c5.73,3.31,9.81,7.2,12.26,11.34h2.77V358h0c-.37,7.29-5.36,14.51-15,20.08a55.91,55.91,0,0,1-8.26,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18,332.27a56.94,56.94,0,0,0-8.26,3.87c-5.73,3.31-9.81,7.2-12.26,11.34H94.89V358h0c.37,7.29,5.39,14.51,15,20.08a55.91,55.91,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5,326.53c20.05,11.57,20,30.34,0,41.91-17.54,10.12-44.61,11.39-64.53,3.8h0l-.8-.31a56.45,56.45,0,0,1-7.25-3.49c-16.72-9.65-19.49-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C130,315,162.46,315,182.5,326.53Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5,326.53c20.05,11.57,20,30.34,0,41.91-17.54,10.12-44.61,11.39-64.53,3.8h0l-.8-.31a56.45,56.45,0,0,1-7.25-3.49c-16.72-9.65-19.49-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C130,315,162.46,315,182.5,326.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.59,332.83c-.21.24-7.22,7.64-5.37,18.28,1.78,10.18,16,18.76,21,20.82a56.45,56.45,0,0,1-7.25-3.49C93.2,358.79,90.43,344.14,101.59,332.83Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.83,362.14c.21-.24,7.22-7.64,5.37-18.28-1.78-10.18-16-18.75-20.95-20.81a55.11,55.11,0,0,1,7.25,3.48C199.22,336.18,202,350.83,190.83,362.14Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,366.92c18.64-10.75,18.64-28.2,0-38.95s-48.84-10.76-67.47,0-18.63,28.2,0,38.95S161.33,377.68,180,366.92Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,366.92c18.64-10.75,18.64-28.2,0-38.95s-48.84-10.76-67.47,0-18.63,28.2,0,38.95S161.33,377.68,180,366.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.77,355.67c3.84-7.09,2.58-14.9-3.74-21.53A33.11,33.11,0,0,0,184,330.6a40.94,40.94,0,0,0-3.86-2.54c-.76-.45-1.54-.87-2.35-1.28,2,3.26,1.26,6.76-10,7.42-22,1.28,5.88,22.3,5.88,22.3S187.84,349.65,191.77,355.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.5,349.86c3.3-.37,4.94-3.76,3.66-7.58s-5-6.61-8.3-6.24-4.94,3.76-3.66,7.58S186.2,350.23,189.5,349.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.72,367.37c-1.08-8.16-36.78-30.77-36.78-30.77s-7.91-3.18-5.29-8.71a41,41,0,0,0-3.81,2.47c-.83.59-1.6,1.21-2.32,1.83-10.63,9.21-10.64,21.29,0,30.51.72.62,1.5,1.24,2.32,1.83a40.09,40.09,0,0,0,3.54,2.31c1.21.71,2.47,1.36,3.78,2,1,.49,2.12.95,3.21,1.38s2.21.84,3.35,1.21A71,71,0,0,0,133.37,374c.79.13,1.6.24,2.4.35a81.82,81.82,0,0,0,10.64.66,80.48,80.48,0,0,0,13-1.06S153.7,372.74,154.72,367.37Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.72,367.37c-1.08-8.16-36.78-30.77-36.78-30.77s-7.91-3.18-5.29-8.71a41,41,0,0,0-3.81,2.47c-.83.59-1.6,1.21-2.32,1.83-10.63,9.21-10.64,21.29,0,30.51.72.62,1.5,1.24,2.32,1.83a40.09,40.09,0,0,0,3.54,2.31c1.21.71,2.47,1.36,3.78,2,1,.49,2.12.95,3.21,1.38s2.21.84,3.35,1.21A71,71,0,0,0,133.37,374c.79.13,1.6.24,2.4.35a81.82,81.82,0,0,0,10.64.66,80.48,80.48,0,0,0,13-1.06S153.7,372.74,154.72,367.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.08,332.93c-13.32,7.69-13.86,20-1.63,28,.52.34,1.07.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.57-.32-1.15-.64-1.75-.94C155.64,324.93,134.39,325.25,121.08,332.93Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.08,332.93c-13.32,7.69-13.86,20-1.63,28,.52.34,1.07.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.57-.32-1.15-.64-1.75-.94C155.64,324.93,134.39,325.25,121.08,332.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,333.57c-13.27,7.66-13.27,20.08,0,27.74s34.78,7.66,48,0,13.27-20.08,0-27.74S135.47,325.91,122.21,333.57Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,333.57c-13.27,7.66-13.27,20.08,0,27.74s34.78,7.66,48,0,13.27-20.08,0-27.74S135.47,325.91,122.21,333.57Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,339c13.26-7.66,34.78-7.66,48,0,5.43,3.14,8.63,7.07,9.62,11.14-1,4.07-4.19,8-9.62,11.13-13.26,7.66-34.78,7.66-48,0-5.43-3.13-8.63-7.06-9.62-11.13C113.58,346.11,116.78,342.18,122.21,339Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,339c13.26-7.66,34.78-7.66,48,0,5.43,3.14,8.63,7.07,9.62,11.14-1,4.07-4.19,8-9.62,11.13-13.26,7.66-34.78,7.66-48,0-5.43-3.13-8.63-7.06-9.62-11.13C113.58,346.11,116.78,342.18,122.21,339Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,353.35c0-.66,0-3.36,0-4.05,0-1.66-1.16-3.28-3.63-4.73l-.09-.05c-4.56-2.64-9.27-2.29-13.47-1.23h0c-1.78.45-3.48,1-5,1.56a47.53,47.53,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.43,5.43,0,0,1-2.12-.56l.17-.12c.16-.11.34-.22.53-.33a14.46,14.46,0,0,1,1.42-.71,9.93,9.93,0,0,1,7.56-.17l4.35-4.39v-4A20.72,20.72,0,0,0,137.4,336a24.22,24.22,0,0,0-3.78,1.31l-4.36-2.51-5.2,3v4l1.78,1a4.32,4.32,0,0,0-.76,2.35c0,.67,0,3.35,0,4,0,1.66,1.2,3.27,3.71,4.72A15.09,15.09,0,0,0,136,356h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.67c.51-.17,1-.34,1.5-.52l-4.38,4.4v4a21.34,21.34,0,0,0,16.8-.73l4.3,2.49,5.2-3v-4l-1.79-1A4.57,4.57,0,0,0,167.62,353.35Zm-11-.34a10.46,10.46,0,0,1-1.21.6,11.17,11.17,0,0,1-8.5.12c4.07-1.43,7.47-2.69,10.37-1.15A6.85,6.85,0,0,1,156.66,353Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,343.29h0c-1.78.45-3.48,1-5,1.56a47.53,47.53,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.37,5.37,0,0,1-2.47-.74c-1.67-1-1.91-2.38.52-4,.16-.11.34-.22.53-.33a12.53,12.53,0,0,1,1.42-.71,9.84,9.84,0,0,1,7.56-.17l4.35-4.39A20.72,20.72,0,0,0,137.4,336a24.22,24.22,0,0,0-3.78,1.31l-4.36-2.51-5.2,3,4.31,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.6A15.1,15.1,0,0,0,136,352h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.66c5-1.67,9-3.64,12.39-1.7,2.26,1.3,1.63,2.94-.84,4.37a10.46,10.46,0,0,1-1.21.6,11.15,11.15,0,0,1-8.65.06l-4.57,4.58a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3-4.3-2.48c4.32-3.35,4.82-7-.23-9.95l-.09-.05C159.35,341.88,154.64,342.23,150.44,343.29Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.44,343.29h0c-1.78.45-3.48,1-5,1.56a47.53,47.53,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.37,5.37,0,0,1-2.47-.74c-1.67-1-1.91-2.38.52-4,.16-.11.34-.22.53-.33a12.53,12.53,0,0,1,1.42-.71,9.84,9.84,0,0,1,7.56-.17l4.35-4.39A20.72,20.72,0,0,0,137.4,336a24.22,24.22,0,0,0-3.78,1.31l-4.36-2.51-5.2,3,4.31,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.6A15.1,15.1,0,0,0,136,352h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.66c5-1.67,9-3.64,12.39-1.7,2.26,1.3,1.63,2.94-.84,4.37a10.46,10.46,0,0,1-1.21.6,11.15,11.15,0,0,1-8.65.06l-4.57,4.58a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3-4.3-2.48c4.32-3.35,4.82-7-.23-9.95l-.09-.05C159.35,341.88,154.64,342.23,150.44,343.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "124.06 337.82 129.31 335.44 133.62 337.33 129.26 334.82 124.06 337.82",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,336.19a24.26,24.26,0,0,1,11.18.38l-3,4.28,4.35-4.39A20.72,20.72,0,0,0,136.8,336.19Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.91,344.52l.09.05c5.05,3,4.55,6.6.23,9.95,3.83-4.17,3.14-7.09-1-9.49s-9.48-2.37-12.77-1.74C154.64,342.23,159.35,341.88,163.91,344.52Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.23 354.52 167.53 357.06 163.33 360.01 168.53 357 164.23 354.52",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,353.61a11.19,11.19,0,0,1-8.28.72l-4.94,3.92,4.57-4.58A11.15,11.15,0,0,0,155.45,353.61Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,346.53c-2,.77-4.8.64-6.23-.59s-.54-2.68,1.71-3.88c-2.43,1.59-2.19,3-.52,4a5.37,5.37,0,0,0,2.47.74A9.47,9.47,0,0,0,140,346.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.33,340.34c-.37.33-3.5,3.24-2.12,6.16,1.47,3.11,6.06,5.11,9.76,5.51h0a15.1,15.1,0,0,1-7.17-2.07C123.87,347.11,124,343.66,128.33,340.34Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.69,335.76c2.46-4.15,6.54-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.73,3.3,9.81,7.19,12.26,11.34h2.78v10.48h0c-.37,7.29-5.36,14.52-15,20.08-20,11.58-52.54,11.58-72.58,0-9.64-5.56-14.66-12.79-15-20.08h0V335.76Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.69,335.76c2.46-4.15,6.54-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.73,3.3,9.81,7.19,12.26,11.34h2.78v10.48h0c-.37,7.29-5.36,14.52-15,20.08-20,11.58-52.54,11.58-72.58,0-9.64-5.56-14.66-12.79-15-20.08h0V335.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,315.74c13.13,0,26.27,2.89,36.29,8.68,5.73,3.3,9.81,7.19,12.26,11.34h2.78v10.48h0c-.37,7.29-5.36,14.52-15,20.08-10,5.79-23.16,8.68-36.29,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,320.55a55.91,55.91,0,0,1,8.26,3.87c5.73,3.3,9.81,7.19,12.26,11.34h2.78v10.48h0c-.37,7.29-5.36,14.52-15,20.08a54.91,54.91,0,0,1-8.26,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,320.55a56.39,56.39,0,0,0-8.26,3.87c-5.72,3.3-9.8,7.19-12.26,11.34H84.92v10.48h0c.37,7.29,5.39,14.52,15,20.08a55.37,55.37,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.53,314.81c20.05,11.57,20.05,30.33,0,41.9-17.53,10.13-44.6,11.4-64.53,3.8h0l-.79-.31a53.47,53.47,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C120,303.24,152.49,303.23,172.53,314.81Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.53,314.81c20.05,11.57,20.05,30.33,0,41.9-17.53,10.13-44.6,11.4-64.53,3.8h0l-.79-.31a53.47,53.47,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C120,303.24,152.49,303.23,172.53,314.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.62,321.1c-.21.25-7.22,7.64-5.36,18.29,1.77,10.18,16,18.75,20.95,20.81a53.47,53.47,0,0,1-7.26-3.49C83.24,347.06,80.46,332.41,91.62,321.1Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86,350.42c.22-.24,7.23-7.64,5.37-18.28-1.78-10.19-16-18.76-20.95-20.82a55.15,55.15,0,0,1,7.25,3.49C189.25,324.46,192,339.11,180.86,350.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.26,
    cy: 335.72,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.26,
    cy: 335.72,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8,344c3.84-7.09,2.59-14.91-3.74-21.53a31.48,31.48,0,0,0-4-3.54,39.28,39.28,0,0,0-3.87-2.55c-.76-.44-1.54-.87-2.35-1.27,2,3.26,1.26,6.76-10,7.41-22,1.29,5.88,22.3,5.88,22.3S177.87,337.93,181.8,344Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,338.13c3.3-.37,4.94-3.76,3.66-7.58s-5-6.61-8.3-6.24-4.94,3.76-3.65,7.58S176.23,338.5,179.53,338.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.75,355.65c-1.08-8.17-36.78-30.78-36.78-30.78s-7.91-3.17-5.28-8.71a42,42,0,0,0-3.82,2.47c-.83.6-1.6,1.21-2.32,1.84-10.63,9.2-10.64,21.29,0,30.5.72.63,1.5,1.24,2.32,1.84a40,40,0,0,0,3.54,2.3c1.21.71,2.48,1.37,3.78,2,1,.49,2.12,1,3.22,1.39s2.2.83,3.34,1.21a69.83,69.83,0,0,0,10.65,2.55c.8.13,1.6.25,2.4.35a82,82,0,0,0,10.65.67,80.36,80.36,0,0,0,13-1.07S143.73,361,144.75,355.65Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.75,355.65c-1.08-8.17-36.78-30.78-36.78-30.78s-7.91-3.17-5.28-8.71a42,42,0,0,0-3.82,2.47c-.83.6-1.6,1.21-2.32,1.84-10.63,9.2-10.64,21.29,0,30.5.72.63,1.5,1.24,2.32,1.84a40,40,0,0,0,3.54,2.3c1.21.71,2.48,1.37,3.78,2,1,.49,2.12,1,3.22,1.39s2.2.83,3.34,1.21a69.83,69.83,0,0,0,10.65,2.55c.8.13,1.6.25,2.4.35a82,82,0,0,0,10.65.67,80.36,80.36,0,0,0,13-1.07S143.73,361,144.75,355.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,321.21c-13.32,7.69-13.86,20-1.62,28,.51.34,1.06.68,1.62,1,13.89,8,36.38,8,50.27,0s13.88-21,0-29c-.56-.33-1.15-.64-1.74-.94C145.67,313.21,124.43,313.52,111.11,321.21Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,321.21c-13.32,7.69-13.86,20-1.62,28,.51.34,1.06.68,1.62,1,13.89,8,36.38,8,50.27,0s13.88-21,0-29c-.56-.33-1.15-.64-1.74-.94C145.67,313.21,124.43,313.52,111.11,321.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.26,
    cy: 335.72,
    rx: 33.98,
    ry: 19.62,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.26,
    cy: 335.72,
    rx: 33.98,
    ry: 19.62,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24,327.32c13.27-7.66,34.78-7.66,48.05,0,5.42,3.13,8.63,7.06,9.61,11.13-1,4.08-4.19,8-9.61,11.14-13.27,7.66-34.78,7.66-48,0-5.43-3.13-8.63-7.06-9.62-11.14C103.61,334.38,106.81,330.45,112.24,327.32Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24,327.32c13.27-7.66,34.78-7.66,48.05,0,5.42,3.13,8.63,7.06,9.61,11.13-1,4.08-4.19,8-9.61,11.14-13.27,7.66-34.78,7.66-48,0-5.43-3.13-8.63-7.06-9.62-11.14C103.61,334.38,106.81,330.45,112.24,327.32Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66,341.63c0-.66,0-3.36,0-4.06,0-1.66-1.15-3.27-3.63-4.72l-.08-.06c-4.57-2.63-9.28-2.29-13.48-1.23h0c-1.78.45-3.48,1-5,1.56a52.11,52.11,0,0,1-5.4,1.67h0a9.47,9.47,0,0,1-2.56.25,5.44,5.44,0,0,1-2.13-.57l.17-.11A4.72,4.72,0,0,1,126,334a11.87,11.87,0,0,1,1.43-.71,9.81,9.81,0,0,1,7.55-.17l4.36-4.4v-4a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.36-2.52-5.2,3v4l1.79,1a4.31,4.31,0,0,0-.77,2.35c0,.67,0,3.35,0,4,0,1.67,1.19,3.27,3.7,4.72a15.22,15.22,0,0,0,7.18,2.07h0c.48,0,1,0,1.44,0a28.83,28.83,0,0,0,7.71-1.66l1.5-.52-4.39,4.39v4a21.38,21.38,0,0,0,16.8-.73l4.3,2.48,5.2-3v-4l-1.78-1A4.77,4.77,0,0,0,157.66,341.63Zm-11-.35a11.22,11.22,0,0,1-9.7.73c4.07-1.44,7.47-2.69,10.36-1.15Q147.05,341.07,146.69,341.28Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47,331.56h0c-1.79.45-3.49,1-5,1.56a52.11,52.11,0,0,1-5.4,1.67h0a9.47,9.47,0,0,1-2.56.25,5.66,5.66,0,0,1-2.48-.74c-1.67-1-1.91-2.38.52-4L126,330a11.77,11.77,0,0,1,1.43-.7,9.81,9.81,0,0,1,7.55-.17l4.36-4.4a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.36-2.52-5.2,3,4.31,2.48,0,0c-4.37,3.32-4.46,6.76.46,9.6a15.22,15.22,0,0,0,7.18,2.07h0q.72,0,1.44,0a28.46,28.46,0,0,0,7.71-1.67c5-1.67,9-3.63,12.39-1.69,2.25,1.3,1.62,2.93-.85,4.36a11.23,11.23,0,0,1-9.86.67l-4.57,4.57a21.34,21.34,0,0,0,16.8-.72l4.3,2.48,5.2-3-4.3-2.48c4.32-3.35,4.82-7-.23-9.95l-.08-.06C149.38,330.16,144.67,330.5,140.47,331.56Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.47,331.56h0c-1.79.45-3.49,1-5,1.56a52.11,52.11,0,0,1-5.4,1.67h0a9.47,9.47,0,0,1-2.56.25,5.66,5.66,0,0,1-2.48-.74c-1.67-1-1.91-2.38.52-4L126,330a11.77,11.77,0,0,1,1.43-.7,9.81,9.81,0,0,1,7.55-.17l4.36-4.4a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.36-2.52-5.2,3,4.31,2.48,0,0c-4.37,3.32-4.46,6.76.46,9.6a15.22,15.22,0,0,0,7.18,2.07h0q.72,0,1.44,0a28.46,28.46,0,0,0,7.71-1.67c5-1.67,9-3.63,12.39-1.69,2.25,1.3,1.62,2.93-.85,4.36a11.23,11.23,0,0,1-9.86.67l-4.57,4.57a21.34,21.34,0,0,0,16.8-.72l4.3,2.48,5.2-3-4.3-2.48c4.32-3.35,4.82-7-.23-9.95l-.08-.06C149.38,330.16,144.67,330.5,140.47,331.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "114.1 326.1 119.34 323.72 123.65 325.61 119.29 323.1 114.1 326.1",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.83,324.46a24.39,24.39,0,0,1,11.18.38l-3,4.29,4.36-4.4A20.76,20.76,0,0,0,126.83,324.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,332.79l.08.06c5.05,3,4.55,6.6.23,9.95,3.83-4.18,3.14-7.09-1-9.49s-9.48-2.38-12.77-1.75C144.67,330.5,149.38,330.16,154,332.79Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.26 342.8 157.56 345.33 153.36 348.28 158.56 345.28 154.26 342.8",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,341.88a11.19,11.19,0,0,1-8.29.73l-4.94,3.91,4.57-4.57A11.18,11.18,0,0,0,145.49,341.88Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,334.8c-2,.77-4.79.64-6.23-.59s-.53-2.68,1.71-3.88c-2.43,1.6-2.19,3-.52,4a5.66,5.66,0,0,0,2.48.74A9.47,9.47,0,0,0,130,334.8Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.36,328.62c-.37.32-3.5,3.24-2.12,6.16,1.47,3.11,6.06,5.1,9.76,5.5h0a15.22,15.22,0,0,1-7.18-2.07C113.9,335.38,114,331.94,118.36,328.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.82,318.07c2.46-4.14,6.54-8,12.26-11.33,20-11.58,52.54-11.58,72.58,0,5.73,3.3,9.81,7.19,12.27,11.33h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.56-14.66-12.79-15-20.08h0V318.07Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.82,318.07c2.46-4.14,6.54-8,12.26-11.33,20-11.58,52.54-11.58,72.58,0,5.73,3.3,9.81,7.19,12.27,11.33h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.56-14.66-12.79-15-20.08h0V318.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.37,298.06c13.14,0,26.27,2.89,36.29,8.68,5.73,3.3,9.81,7.19,12.26,11.33h2.78v10.49h0c-.37,7.29-5.36,14.52-15,20.08-10,5.79-23.15,8.68-36.29,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.4,302.87a54.45,54.45,0,0,1,8.26,3.87c5.73,3.3,9.81,7.19,12.26,11.33h2.78v10.49h0c-.37,7.29-5.36,14.52-15,20.08a55.43,55.43,0,0,1-8.26,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,302.87a55.37,55.37,0,0,0-8.26,3.87c-5.72,3.3-9.8,7.19-12.26,11.33H89.05v10.49h0c.37,7.29,5.39,14.52,15,20.08a56.39,56.39,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,297.12c20,11.58,20,30.34,0,41.91-17.54,10.13-44.61,11.39-64.53,3.8h0l-.79-.31a56.58,56.58,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.33-35.61h0a39.55,39.55,0,0,1,8.32-6.29C124.12,285.55,156.62,285.55,176.67,297.12Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,297.12c20,11.58,20,30.34,0,41.91-17.54,10.13-44.61,11.39-64.53,3.8h0l-.79-.31a56.58,56.58,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.33-35.61h0a39.55,39.55,0,0,1,8.32-6.29C124.12,285.55,156.62,285.55,176.67,297.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,303.42c-.21.24-7.22,7.64-5.36,18.28,1.77,10.19,16,18.76,21,20.82a56.58,56.58,0,0,1-7.26-3.49C87.37,329.38,84.59,314.73,95.75,303.42Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,332.74c.22-.25,7.23-7.64,5.37-18.29-1.78-10.18-16-18.75-21-20.81a53.92,53.92,0,0,1,7.25,3.49C193.38,306.78,196.16,321.42,185,332.74Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.39,
    cy: 318.04,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.39,
    cy: 318.04,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.93,326.26c3.84-7.08,2.59-14.9-3.74-21.53a33.1,33.1,0,0,0-4-3.54,39.86,39.86,0,0,0-3.87-2.54c-.76-.45-1.54-.87-2.35-1.28,2,3.27,1.26,6.76-10,7.42-22,1.28,5.88,22.3,5.88,22.3S182,320.25,185.93,326.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,320.45c3.3-.37,4.93-3.76,3.65-7.58s-5-6.61-8.3-6.24-4.93,3.76-3.65,7.58S180.37,320.82,183.67,320.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,338c-1.08-8.16-36.77-30.77-36.77-30.77s-7.92-3.17-5.29-8.71A41.22,41.22,0,0,0,103,301c-.82.6-1.6,1.21-2.32,1.84-10.63,9.2-10.64,21.29,0,30.5.71.62,1.49,1.24,2.31,1.84,1.1.79,2.27,1.56,3.54,2.3s2.48,1.37,3.78,2c1,.49,2.12,1,3.22,1.39s2.2.83,3.34,1.2a69.24,69.24,0,0,0,10.65,2.56c.8.13,1.6.25,2.4.35a83.78,83.78,0,0,0,10.65.67,81.5,81.5,0,0,0,13-1.07S147.86,343.33,148.88,338Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,338c-1.08-8.16-36.77-30.77-36.77-30.77s-7.92-3.17-5.29-8.71A41.22,41.22,0,0,0,103,301c-.82.6-1.6,1.21-2.32,1.84-10.63,9.2-10.64,21.29,0,30.5.71.62,1.49,1.24,2.31,1.84,1.1.79,2.27,1.56,3.54,2.3s2.48,1.37,3.78,2c1,.49,2.12,1,3.22,1.39s2.2.83,3.34,1.2a69.24,69.24,0,0,0,10.65,2.56c.8.13,1.6.25,2.4.35a83.78,83.78,0,0,0,10.65.67,81.5,81.5,0,0,0,13-1.07S147.86,343.33,148.88,338Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24,303.53c-13.31,7.68-13.85,20-1.62,28,.52.34,1.06.68,1.63,1,13.88,8,36.38,8,50.26,0s13.88-21,0-29c-.56-.33-1.15-.65-1.74-.95C149.8,295.52,128.56,295.84,115.24,303.53Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24,303.53c-13.31,7.68-13.85,20-1.62,28,.52.34,1.06.68,1.63,1,13.88,8,36.38,8,50.26,0s13.88-21,0-29c-.56-.33-1.15-.65-1.74-.95C149.8,295.52,128.56,295.84,115.24,303.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,304.17c-13.27,7.66-13.27,20.08,0,27.74s34.78,7.66,48,0,13.27-20.08,0-27.74S129.64,296.51,116.37,304.17Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,304.17c-13.27,7.66-13.27,20.08,0,27.74s34.78,7.66,48,0,13.27-20.08,0-27.74S129.64,296.51,116.37,304.17Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,309.64c13.27-7.66,34.78-7.66,48,0,5.42,3.13,8.63,7.06,9.62,11.13-1,4.08-4.2,8-9.62,11.14-13.27,7.66-34.78,7.66-48,0-5.43-3.14-8.63-7.07-9.62-11.14C107.74,316.7,110.94,312.77,116.37,309.64Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,309.64c13.27-7.66,34.78-7.66,48,0,5.42,3.13,8.63,7.06,9.62,11.13-1,4.08-4.2,8-9.62,11.14-13.27,7.66-34.78,7.66-48,0-5.43-3.14-8.63-7.07-9.62-11.14C107.74,316.7,110.94,312.77,116.37,309.64Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79,323.94c0-.66,0-3.36,0-4.05,0-1.66-1.15-3.28-3.63-4.72,0,0-.06,0-.08-.06-4.56-2.63-9.28-2.29-13.48-1.23h0c-1.79.45-3.48,1-5,1.56a50.1,50.1,0,0,1-5.4,1.68h0a9.44,9.44,0,0,1-2.56.24,5.48,5.48,0,0,1-2.13-.56l.17-.12.53-.33a11.77,11.77,0,0,1,1.43-.7,9.81,9.81,0,0,1,7.55-.17l4.36-4.4v-4a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.36-2.52-5.19,3v4l1.78,1a4.34,4.34,0,0,0-.77,2.36c0,.67,0,3.34,0,4,0,1.67,1.19,3.27,3.7,4.72a15.22,15.22,0,0,0,7.18,2.07h0q.72,0,1.44,0a28.46,28.46,0,0,0,7.71-1.67l1.5-.51-4.39,4.39v4a21.34,21.34,0,0,0,16.8-.72l4.3,2.48,5.2-3v-4l-1.78-1A4.78,4.78,0,0,0,161.79,323.94Zm-11-.34a11.22,11.22,0,0,1-9.7.73c4.07-1.44,7.47-2.69,10.36-1.15Q151.18,323.39,150.82,323.6Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,313.88h0c-1.79.45-3.48,1-5,1.56a50.1,50.1,0,0,1-5.4,1.68h0a9.44,9.44,0,0,1-2.56.24,5.52,5.52,0,0,1-2.48-.73c-1.67-1-1.91-2.38.52-4l.53-.33a13.56,13.56,0,0,1,1.43-.71,9.9,9.9,0,0,1,7.55-.17l4.36-4.39a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.36-2.52-5.19,3,4.3,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.61a15.09,15.09,0,0,0,7.18,2.06h0q.72,0,1.44,0a28.46,28.46,0,0,0,7.71-1.67c5-1.67,9-3.63,12.39-1.69,2.25,1.3,1.63,2.93-.85,4.36a11.2,11.2,0,0,1-9.86.66l-4.57,4.58a21.33,21.33,0,0,0,16.8-.73l4.3,2.49,5.2-3-4.3-2.49c4.33-3.34,4.82-7-.23-9.94,0,0-.06,0-.08-.06C153.52,312.48,148.8,312.82,144.6,313.88Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.6,313.88h0c-1.79.45-3.48,1-5,1.56a50.1,50.1,0,0,1-5.4,1.68h0a9.44,9.44,0,0,1-2.56.24,5.52,5.52,0,0,1-2.48-.73c-1.67-1-1.91-2.38.52-4l.53-.33a13.56,13.56,0,0,1,1.43-.71,9.9,9.9,0,0,1,7.55-.17l4.36-4.39a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.36-2.52-5.19,3,4.3,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.61a15.09,15.09,0,0,0,7.18,2.06h0q.72,0,1.44,0a28.46,28.46,0,0,0,7.71-1.67c5-1.67,9-3.63,12.39-1.69,2.25,1.3,1.63,2.93-.85,4.36a11.2,11.2,0,0,1-9.86.66l-4.57,4.58a21.33,21.33,0,0,0,16.8-.73l4.3,2.49,5.2-3-4.3-2.49c4.33-3.34,4.82-7-.23-9.94,0,0-.06,0-.08-.06C153.52,312.48,148.8,312.82,144.6,313.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "118.23 308.41 123.48 306.04 127.78 307.93 123.43 305.41 118.23 308.41",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,306.78a24.26,24.26,0,0,1,11.18.38l-3,4.28,4.36-4.39A20.76,20.76,0,0,0,131,306.78Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,315.11s.06,0,.08.06c5.05,2.95,4.56,6.6.23,9.94,3.83-4.17,3.14-7.08-1-9.49s-9.48-2.37-12.77-1.74C148.8,312.82,153.52,312.48,158.08,315.11Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.39 325.11 161.69 327.65 157.49 330.6 162.69 327.6 158.39 325.11",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,324.2a11.15,11.15,0,0,1-8.29.72l-4.94,3.92,4.57-4.58A11.13,11.13,0,0,0,149.62,324.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,317.12c-2,.77-4.79.64-6.22-.59s-.54-2.68,1.7-3.88c-2.43,1.6-2.19,3-.52,4a5.52,5.52,0,0,0,2.48.73A9.44,9.44,0,0,0,134.13,317.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49,310.93c-.37.33-3.5,3.25-2.11,6.16,1.46,3.11,6.05,5.11,9.75,5.51h0a15.09,15.09,0,0,1-7.18-2.06C118,317.7,118.12,314.25,122.49,310.93Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.41,303.16c2.45-4.14,6.53-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.73,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.56-14.67-12.79-15-20.08h0V303.16Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,303.16c2.45-4.14,6.53-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.73,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.56-14.67-12.79-15-20.08h0V303.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,283.14c13.13,0,26.27,2.9,36.29,8.68,5.73,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08-10,5.79-23.16,8.68-36.29,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,288a55.87,55.87,0,0,1,8.26,3.86c5.73,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.52-15,20.08A55.91,55.91,0,0,1,212,337.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,288a55.87,55.87,0,0,0-8.26,3.86c-5.72,3.31-9.81,7.2-12.26,11.34h-2.77v10.49h0c.37,7.29,5.39,14.52,15,20.08a55.91,55.91,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.25,282.21c20.05,11.58,20,30.34,0,41.91-17.53,10.12-44.61,11.39-64.53,3.8h0l-.8-.31a56.45,56.45,0,0,1-7.25-3.49c-16.72-9.65-19.49-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C167.71,270.64,200.21,270.64,220.25,282.21Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.25,282.21c20.05,11.58,20,30.34,0,41.91-17.53,10.12-44.61,11.39-64.53,3.8h0l-.8-.31a56.45,56.45,0,0,1-7.25-3.49c-16.72-9.65-19.49-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C167.71,270.64,200.21,270.64,220.25,282.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,288.51c-.21.24-7.22,7.64-5.37,18.28,1.78,10.19,16,18.76,20.95,20.82a56.45,56.45,0,0,1-7.25-3.49C131,314.47,128.18,299.82,139.34,288.51Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.58,317.82c.21-.24,7.22-7.63,5.37-18.28-1.78-10.18-16-18.75-20.95-20.81a55.11,55.11,0,0,1,7.25,3.48C237,291.86,239.74,306.51,228.58,317.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,322.6c18.64-10.75,18.64-28.19,0-39s-48.84-10.76-67.47,0-18.63,28.2,0,39S199.08,333.36,217.71,322.6Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,322.6c18.64-10.75,18.64-28.19,0-39s-48.84-10.76-67.47,0-18.63,28.2,0,39S199.08,333.36,217.71,322.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52,311.35c3.84-7.09,2.59-14.9-3.74-21.53a32.38,32.38,0,0,0-4.05-3.54,40.94,40.94,0,0,0-3.86-2.54c-.76-.45-1.54-.87-2.35-1.28,2,3.27,1.26,6.76-10,7.42-22,1.28,5.88,22.3,5.88,22.3S225.59,305.33,229.52,311.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.25,305.54c3.3-.37,4.94-3.76,3.66-7.58s-5-6.61-8.3-6.24-4.94,3.76-3.65,7.58S224,305.91,227.25,305.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,323.05c-1.08-8.16-36.78-30.77-36.78-30.77s-7.91-3.18-5.29-8.71a41,41,0,0,0-3.81,2.47,29.33,29.33,0,0,0-2.32,1.84c-10.63,9.2-10.64,21.28,0,30.5.72.62,1.5,1.24,2.32,1.84,1.09.79,2.27,1.56,3.54,2.3s2.47,1.37,3.78,2c1,.49,2.12.95,3.21,1.38s2.21.84,3.35,1.21a69.85,69.85,0,0,0,10.65,2.56c.79.13,1.6.24,2.4.35a83.67,83.67,0,0,0,10.65.67,81.59,81.59,0,0,0,13-1.07S191.45,328.42,192.47,323.05Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,323.05c-1.08-8.16-36.78-30.77-36.78-30.77s-7.91-3.18-5.29-8.71a41,41,0,0,0-3.81,2.47,29.33,29.33,0,0,0-2.32,1.84c-10.63,9.2-10.64,21.28,0,30.5.72.62,1.5,1.24,2.32,1.84,1.09.79,2.27,1.56,3.54,2.3s2.47,1.37,3.78,2c1,.49,2.12.95,3.21,1.38s2.21.84,3.35,1.21a69.85,69.85,0,0,0,10.65,2.56c.79.13,1.6.24,2.4.35a83.67,83.67,0,0,0,10.65.67,81.59,81.59,0,0,0,13-1.07S191.45,328.42,192.47,323.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,288.61c-13.32,7.69-13.86,20-1.63,28,.52.34,1.07.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.57-.32-1.15-.64-1.75-.94C193.39,280.61,172.14,280.93,158.83,288.61Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,288.61c-13.32,7.69-13.86,20-1.63,28,.52.34,1.07.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.57-.32-1.15-.64-1.75-.94C193.39,280.61,172.14,280.93,158.83,288.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.98,
    cy: 303.12,
    rx: 33.98,
    ry: 19.62,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.98,
    cy: 303.12,
    rx: 33.98,
    ry: 19.62,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,294.73c13.26-7.67,34.78-7.67,48,0,5.43,3.13,8.63,7.06,9.62,11.13-1,4.07-4.19,8-9.62,11.13-13.26,7.66-34.78,7.66-48,0-5.43-3.13-8.63-7.06-9.62-11.13C151.33,301.79,154.53,297.86,160,294.73Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,294.73c13.26-7.67,34.78-7.67,48,0,5.43,3.13,8.63,7.06,9.62,11.13-1,4.07-4.19,8-9.62,11.13-13.26,7.66-34.78,7.66-48,0-5.43-3.13-8.63-7.06-9.62-11.13C151.33,301.79,154.53,297.86,160,294.73Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,309c0-.66,0-3.36,0-4,0-1.66-1.16-3.28-3.63-4.73l-.09-.05c-4.56-2.63-9.27-2.29-13.47-1.23h0c-1.78.45-3.48,1-5,1.56a47.53,47.53,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.43,5.43,0,0,1-2.12-.56l.17-.12c.16-.11.34-.22.53-.33a12.42,12.42,0,0,1,1.42-.7,9.88,9.88,0,0,1,7.56-.18l4.35-4.39v-4a20.72,20.72,0,0,0-11.91-.44,26.48,26.48,0,0,0-3.78,1.31L167,290.5l-5.2,3v4l1.78,1a4.32,4.32,0,0,0-.76,2.35c0,.67,0,3.35,0,4,0,1.66,1.2,3.27,3.71,4.72a15.09,15.09,0,0,0,7.17,2.06h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.67c.52-.17,1-.34,1.5-.52l-4.38,4.4v4a21.38,21.38,0,0,0,16.8-.72l4.3,2.48,5.2-3v-4l-1.79-1A4.57,4.57,0,0,0,205.37,309Zm-11-.34a10.46,10.46,0,0,1-1.21.6,11.22,11.22,0,0,1-8.5.13c4.07-1.44,7.47-2.7,10.37-1.15Q194.77,308.48,194.41,308.69Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,299h0c-1.78.45-3.48,1-5,1.56a47.53,47.53,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.37,5.37,0,0,1-2.47-.74c-1.67-1-1.91-2.38.52-4,.16-.11.34-.22.53-.33a14.46,14.46,0,0,1,1.42-.71,9.88,9.88,0,0,1,7.56-.17l4.35-4.39a20.72,20.72,0,0,0-11.91-.44,26.48,26.48,0,0,0-3.78,1.31L167,290.5l-5.2,3,4.31,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.6a15.1,15.1,0,0,0,7.17,2.07h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.66c5-1.67,9-3.64,12.39-1.7,2.26,1.3,1.63,2.94-.84,4.37a10.46,10.46,0,0,1-1.21.6,11.15,11.15,0,0,1-8.65.06L180,313.93a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3L202,310.2c4.32-3.34,4.82-7-.23-9.95l-.09-.05C197.1,297.57,192.39,297.91,188.19,299Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.19,299h0c-1.78.45-3.48,1-5,1.56a47.53,47.53,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.37,5.37,0,0,1-2.47-.74c-1.67-1-1.91-2.38.52-4,.16-.11.34-.22.53-.33a14.46,14.46,0,0,1,1.42-.71,9.88,9.88,0,0,1,7.56-.17l4.35-4.39a20.72,20.72,0,0,0-11.91-.44,26.48,26.48,0,0,0-3.78,1.31L167,290.5l-5.2,3,4.31,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.6a15.1,15.1,0,0,0,7.17,2.07h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.66c5-1.67,9-3.64,12.39-1.7,2.26,1.3,1.63,2.94-.84,4.37a10.46,10.46,0,0,1-1.21.6,11.15,11.15,0,0,1-8.65.06L180,313.93a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3L202,310.2c4.32-3.34,4.82-7-.23-9.95l-.09-.05C197.1,297.57,192.39,297.91,188.19,299Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "161.81 293.5 167.06 291.12 171.37 293.02 167.01 290.5 161.81 293.5",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,291.87a24.26,24.26,0,0,1,11.18.38l-3,4.28,4.35-4.39A20.72,20.72,0,0,0,174.55,291.87Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.66,300.2l.09.05c5.05,3,4.55,6.61.23,9.95,3.83-4.17,3.14-7.08-1-9.49s-9.48-2.37-12.77-1.74C192.39,297.91,197.1,297.57,201.66,300.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.98 310.2 205.28 312.74 201.08 315.69 206.28 312.69 201.98 310.2",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,309.29a11.19,11.19,0,0,1-8.28.72L180,313.93l4.57-4.58A11.15,11.15,0,0,0,193.2,309.29Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,302.21c-2,.77-4.8.64-6.23-.59s-.54-2.68,1.71-3.88c-2.43,1.59-2.19,3-.52,4a5.37,5.37,0,0,0,2.47.74A9.47,9.47,0,0,0,177.72,302.21Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,296c-.37.33-3.5,3.24-2.12,6.16,1.47,3.11,6.06,5.11,9.76,5.51h0a15.1,15.1,0,0,1-7.17-2.07C161.62,302.79,161.71,299.34,166.08,296Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.79,316.79c2.37,4.17,3.7,9.61,3.7,16.17,0,23-16.27,50.92-36.33,62.41-5.73,3.28-11.15,4.86-16,4.91l-1.38,2.39-9.09-5.21v0c-6.13-3.94-9.9-11.81-9.9-22.86,0-23,16.26-50.92,36.33-62.41,9.65-5.53,18.43-6.26,24.93-3h0l9.09,5.21Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,316.79c2.37,4.17,3.7,9.61,3.7,16.17,0,23-16.27,50.92-36.33,62.41-5.73,3.28-11.15,4.86-16,4.91l-1.38,2.39-9.09-5.21v0c-6.13-3.94-9.9-11.81-9.9-22.86,0-23,16.26-50.92,36.33-62.41,9.65-5.53,18.43-6.26,24.93-3h0l9.09,5.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.85,368.47c-6.58,11.3-15.66,21.16-25.69,26.9-5.73,3.28-11.15,4.86-16,4.91l-1.38,2.39-9.09-5.21v0c-6.13-3.94-9.9-11.81-9.9-22.86,0-11.49,4.07-24.22,10.64-35.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,390.19a56.69,56.69,0,0,1-7.49,5.18c-5.73,3.28-11.15,4.86-16,4.91l-1.38,2.39-9.09-5.21v0c-6.13-3.94-9.9-11.81-9.9-22.86a55.09,55.09,0,0,1,.78-9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71,342a56,56,0,0,0,.78-9c0-6.56-1.33-12-3.7-16.17l1.39-2.38-9.09-5.21h0c-6.5-3.3-15.28-2.57-24.93,3a56.69,56.69,0,0,0-7.49,5.18Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.49,400.14c-20.06,11.49-36.33,2.18-36.33-20.8,0-20.11,12.45-44,29-57.37h0c.22-.18.44-.36.67-.53a55.23,55.23,0,0,1,6.65-4.51c16.73-9.58,30.82-4.7,35,10.52h0a38.54,38.54,0,0,1,1.29,10.28C259.82,360.71,243.55,388.65,223.49,400.14Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.49,400.14c-20.06,11.49-36.33,2.18-36.33-20.8,0-20.11,12.45-44,29-57.37h0c.22-.18.44-.36.67-.53a55.23,55.23,0,0,1,6.65-4.51c16.73-9.58,30.82-4.7,35,10.52h0a38.54,38.54,0,0,1,1.29,10.28C259.82,360.71,243.55,388.65,223.49,400.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.53,327.45c-.1-.31-3-10-13.16-13.69-9.72-3.53-24.29,4.47-28.53,7.68a55.23,55.23,0,0,1,6.65-4.51C240.22,307.35,254.31,312.23,258.53,327.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,389.62c.1.31,3,10,13.16,13.69,9.72,3.53,24.29-4.47,28.53-7.68a55.23,55.23,0,0,1-6.65,4.51C206.76,409.72,192.67,404.84,188.45,389.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.51,
    cy: 358.57,
    rx: 47.47,
    ry: 27.52,
    transform: "translate(-198.87 369.84) rotate(-59.59)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.51,
    cy: 358.57,
    rx: 47.47,
    ry: 27.52,
    transform: "translate(-198.87 369.84) rotate(-59.59)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.18,315.33c8.06.22,14.21,5.17,16.79,13.91a32.06,32.06,0,0,1,1,5.23,39.26,39.26,0,0,1,.28,4.58c0,.88,0,1.76-.07,2.66-1.84-3.33-5.24-4.44-11.43,4.9-12.12,18.27-16.39-16.12-16.39-16.12S242.43,321.69,239.18,315.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,320.16c2-2.65,5.73-2.37,8.4.63s3.23,7.58,1.26,10.23-5.73,2.38-8.4-.62S241.11,322.82,243.08,320.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,341.38c6.54,5,8.27,46.9,8.27,46.9s-1.21,8.38,4.9,8.87a40.58,40.58,0,0,1-4,2.05c-.93.42-1.84.78-2.75,1.09-13.29,4.57-23.78-1.42-26.44-15.15-.18-.93-.33-1.9-.43-2.9a40.11,40.11,0,0,1-.23-4.19c0-1.39.06-2.81.18-4.23.09-1.14.23-2.3.41-3.46s.38-2.31.62-3.47a69.64,69.64,0,0,1,3.12-10.43c.28-.75.58-1.49.89-2.23a83.2,83.2,0,0,1,4.75-9.49,81,81,0,0,1,7.45-10.67S205.32,339.59,210.49,341.38Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,341.38c6.54,5,8.27,46.9,8.27,46.9s-1.21,8.38,4.9,8.87a40.58,40.58,0,0,1-4,2.05c-.93.42-1.84.78-2.75,1.09-13.29,4.57-23.78-1.42-26.44-15.15-.18-.93-.33-1.9-.43-2.9a40.11,40.11,0,0,1-.23-4.19c0-1.39.06-2.81.18-4.23.09-1.14.23-2.3.41-3.46s.38-2.31.62-3.47a69.64,69.64,0,0,1,3.12-10.43c.28-.75.58-1.49.89-2.23a83.2,83.2,0,0,1,4.75-9.49,81,81,0,0,1,7.45-10.67S205.32,339.59,210.49,341.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,387.4c-13.33,7.63-24.23,2-25.1-12.51,0-.61-.06-1.25-.06-1.9,0-15.91,11.26-35.26,25.16-43.22s25.16-1.51,25.16,14.41c0,.64,0,1.31-.06,2C247.74,361.66,236.84,379.77,223.51,387.4Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,387.4c-13.33,7.63-24.23,2-25.1-12.51,0-.61-.06-1.25-.06-1.9,0-15.91,11.26-35.26,25.16-43.22s25.16-1.51,25.16,14.41c0,.64,0,1.31-.06,2C247.74,361.66,236.84,379.77,223.51,387.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,386.11c-13.28,7.61-24.05,1.44-24.05-13.77s10.77-33.71,24.05-41.31,24-1.44,24,13.77S236.8,378.51,223.52,386.11Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,386.11c-13.28,7.61-24.05,1.44-24.05-13.77s10.77-33.71,24.05-41.31,24-1.44,24,13.77S236.8,378.51,223.52,386.11Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.77,383.4c13.29-7.61,24-26.11,24-41.32,0-6.22-1.8-10.92-4.84-13.79-4-1.18-9-.37-14.46,2.74-13.28,7.6-24.05,26.1-24.05,41.31,0,6.22,1.8,10.93,4.84,13.8C208.33,387.31,213.34,386.51,218.77,383.4Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.77,383.4c13.29-7.61,24-26.11,24-41.32,0-6.22-1.8-10.92-4.84-13.79-4-1.18-9-.37-14.46,2.74-13.28,7.6-24.05,26.1-24.05,41.31,0,6.22,1.8,10.93,4.84,13.8C208.33,387.31,213.34,386.51,218.77,383.4Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.93,352.49a5.51,5.51,0,0,0-3.53-.51h0a26.68,26.68,0,0,0-3.84.88c-1,.28-1.86.52-2.63.69,0-1.92,1.13-4.08,3.68-5.74l.55-.34a9.84,9.84,0,0,1,1.32-.64c.11-.05.22-.07.33-.11h0l0,0c2-.67,3.16.15,3.53,2.07l5.95-5.31a5.46,5.46,0,0,0-2.38-3.62c-.59-.34-2.66-1.53-3.26-1.86a5.33,5.33,0,0,0-2.87-.73v-2.11l-3.55-2.05-5.16,3,0,5-.05,0c-5,3.7-8,8.84-8.06,14.54,0,2.8.67,4.38,1.76,5.2h0c.22.17,3.13,1.74,3.55,2.06h0a3.4,3.4,0,0,0,.71.42c1.46.6,3.38.27,5.25-.25,1.43-.38,2.84-.85,4-1.12,0,.06,0,.1,0,.16,0,2.61-1.73,4.87-4.19,6.29a7.58,7.58,0,0,1-1.11.55,5.62,5.62,0,0,1-.67.21,3.75,3.75,0,0,1-.12-.6l-3.55-2L209.42,372c.36,2.14,1.17,3.45,2.27,4.15.65.43,3.07,1.75,3.6,2.08a4.81,4.81,0,0,0,3.05.62v2l3.54,2.05,5.17-3v-5c5-3.76,8.42-9.07,8.48-15v-.1c0-3-.83-4.57-2.1-5.31Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,354h0a27.59,27.59,0,0,0-3.83.87,20.17,20.17,0,0,1-4.11.93h0a2.09,2.09,0,0,1-1.48-.39,2.25,2.25,0,0,1-.58-1.83c0-1.94,1.1-4.13,3.68-5.81l.55-.34a9.84,9.84,0,0,1,1.32-.64c2.27-.9,3.48-.08,3.88,1.95l5.95-5.31c-.78-3.1-2.66-4.49-5.52-4.14a12.25,12.25,0,0,0-3,.86l0-5-5.17,3v5l-.05,0c-5,3.7-8.05,8.84-8.07,14.54,0,2.8.68,4.38,1.77,5.2h0a3.4,3.4,0,0,0,.71.42c1.46.6,3.38.27,5.25-.25,3.91-1,7.61-2.8,7.59,1.09,0,2.61-1.73,4.87-4.18,6.29a7.65,7.65,0,0,1-1.12.55c-2.73,1.11-4.06-.34-4.33-2.44L213,374.06c.92,5.54,4.92,5.54,8.93,3.83l0,5,5.17-3v-5c5-3.76,8.42-9.07,8.48-15v-.1C235.56,354.53,232.93,353.67,230,354Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230,354h0a27.59,27.59,0,0,0-3.83.87,20.17,20.17,0,0,1-4.11.93h0a2.09,2.09,0,0,1-1.48-.39,2.25,2.25,0,0,1-.58-1.83c0-1.94,1.1-4.13,3.68-5.81l.55-.34a9.84,9.84,0,0,1,1.32-.64c2.27-.9,3.48-.08,3.88,1.95l5.95-5.31c-.78-3.1-2.66-4.49-5.52-4.14a12.25,12.25,0,0,0-3,.86l0-5-5.17,3v5l-.05,0c-5,3.7-8.05,8.84-8.07,14.54,0,2.8.68,4.38,1.77,5.2h0a3.4,3.4,0,0,0,.71.42c1.46.6,3.38.27,5.25-.25,3.91-1,7.61-2.8,7.59,1.09,0,2.61-1.73,4.87-4.18,6.29a7.65,7.65,0,0,1-1.12.55c-2.73,1.11-4.06-.34-4.33-2.44L213,374.06c.92,5.54,4.92,5.54,8.93,3.83l0,5,5.17-3v-5c5-3.76,8.42-9.07,8.48-15v-.1C235.56,354.53,232.93,353.67,230,354Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "221.62 338.12 226.27 336.09 226.77 340.18 226.78 335.14 221.62 338.12",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,339.4a5.19,5.19,0,0,1,5.2,3.83l-5.19,5.54,5.94-5.31C234.27,339.88,232.15,338.83,229.33,339.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.54,359.82v.1c-.06,5.92-3.45,11.23-8.48,15,5.5-5.14,7.67-9.71,7.69-14.53s-2.64-6.33-4.8-6.35C232.93,353.67,235.56,354.53,235.54,359.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.06 374.91 226.5 379.67 221.88 382.87 227.05 379.89 227.06 374.91",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,371c-4.12,1.91-4.72-1.34-4.72-1.34L213,374.06l6.21-5.53C219.45,370.63,220.78,372.08,223.51,371Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,355.83c-1.64.58-2.92-.45-2.57-2.71a7.51,7.51,0,0,1,4.19-5.32c-2.58,1.68-3.68,3.87-3.68,5.81a2.25,2.25,0,0,0,.58,1.83A2.09,2.09,0,0,0,222,355.83Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.56,343.14a23.4,23.4,0,0,0-6.37,8.62c-2,5.09-1.41,9.43.07,11.11h0c-1.09-.82-1.78-2.4-1.77-5.2C213.51,352,216.53,346.84,221.56,343.14Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.18 322.36 256.03 328.33 246.89 324.58 237.75 338.8 245.6 323.83 237.75 317.86 246.89 321.61 256.03 307.39 248.18 322.36",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.05,384.18c2.37-4.19,6.38-8.16,12-11.58,19.81-12,52.3-12.62,72.57-1.46,5.79,3.19,10,7,12.49,11.09l2.77-.05.21,10.48h0c-.22,7.3-5.07,14.63-14.59,20.38-19.81,12-52.3,12.62-72.57,1.45-9.75-5.37-14.92-12.49-15.43-19.77h0l-.21-10.49Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,384.18c2.37-4.19,6.38-8.16,12-11.58,19.81-12,52.3-12.62,72.57-1.46,5.79,3.19,10,7,12.49,11.09l2.77-.05.21,10.48h0c-.22,7.3-5.07,14.63-14.59,20.38-19.81,12-52.3,12.62-72.57,1.45-9.75-5.37-14.92-12.49-15.43-19.77h0l-.21-10.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,363.19c13.13-.26,26.32,2.37,36.46,7.95,5.79,3.19,10,7,12.49,11.09l2.77-.05.21,10.48h0c-.22,7.3-5.07,14.63-14.59,20.38-9.9,6-23,9.14-36.11,9.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,367.44a55.31,55.31,0,0,1,8.34,3.7c5.79,3.19,10,7,12.49,11.09l2.77-.05.21,10.48h0c-.22,7.3-5.07,14.63-14.59,20.38a57.62,57.62,0,0,1-8.18,4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.26,368.56a57.08,57.08,0,0,0-8.18,4c-5.65,3.42-9.66,7.39-12,11.58l-2.77.05.21,10.49h0c.51,7.28,5.68,14.4,15.43,19.77a57.3,57.3,0,0,0,8.34,3.71Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,361.54c20.27,11.16,20.64,29.92.84,41.89-17.33,10.48-44.37,12.29-64.44,5.09h0l-.8-.29a56.11,56.11,0,0,1-7.32-3.34c-16.91-9.32-20-23.91-9-35.44h0a39.09,39.09,0,0,1,8.19-6.45C352.7,351,385.19,350.37,405.46,361.54Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.46,361.54c20.27,11.16,20.64,29.92.84,41.89-17.33,10.48-44.37,12.29-64.44,5.09h0l-.8-.29a56.11,56.11,0,0,1-7.32-3.34c-16.91-9.32-20-23.91-9-35.44h0a39.09,39.09,0,0,1,8.19-6.45C352.7,351,385.19,350.37,405.46,361.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.69,369.45c-.21.25-7.07,7.78-5,18.39,2,10.14,16.41,18.43,21.36,20.39a56.11,56.11,0,0,1-7.32-3.34C316.82,395.57,313.75,381,324.69,369.45Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5,397c.21-.24,7.07-7.78,5-18.38-2-10.15-16.41-18.43-21.37-20.4a55.69,55.69,0,0,1,7.33,3.35C422.36,370.85,425.43,385.44,414.5,397Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.61,
    cy: 383.17,
    rx: 47.71,
    ry: 27.55,
    transform: "translate(-7.59 7.47) rotate(-1.15)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.61,
    cy: 383.17,
    rx: 47.71,
    ry: 27.55,
    transform: "translate(-7.59 7.47) rotate(-1.15)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.31,390.48c3.69-7.16,2.28-15-4.18-21.45a32,32,0,0,0-4.11-3.46,39.63,39.63,0,0,0-3.91-2.46c-.77-.43-1.56-.84-2.38-1.23,2,3.22,1.4,6.73-9.83,7.61-22,1.73,6.33,22.18,6.33,22.18S411.26,384.54,415.31,390.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.93,384.72c3.29-.44,4.85-3.86,3.5-7.65S411.3,370.55,408,371s-4.85,3.86-3.5,7.65S409.63,385.15,412.93,384.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.5,402.92c-1.25-8.14-37.39-30-37.39-30s-8-3-5.46-8.6a42.46,42.46,0,0,0-3.76,2.54c-.82.62-1.58,1.24-2.29,1.89-10.44,9.41-10.21,21.49.62,30.49.73.61,1.52,1.21,2.35,1.79a42.16,42.16,0,0,0,3.58,2.24c1.23.68,2.51,1.31,3.83,1.9,1,.47,2.14.91,3.24,1.32s2.22.79,3.37,1.14a70.53,70.53,0,0,0,10.7,2.35c.79.11,1.6.21,2.4.3a82.2,82.2,0,0,0,10.66.45,81.25,81.25,0,0,0,13-1.33S377.59,408.31,378.5,402.92Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.5,402.92c-1.25-8.14-37.39-30-37.39-30s-8-3-5.46-8.6a42.46,42.46,0,0,0-3.76,2.54c-.82.62-1.58,1.24-2.29,1.89-10.44,9.41-10.21,21.49.62,30.49.73.61,1.52,1.21,2.35,1.79a42.16,42.16,0,0,0,3.58,2.24c1.23.68,2.51,1.31,3.83,1.9,1,.47,2.14.91,3.24,1.32s2.22.79,3.37,1.14a70.53,70.53,0,0,0,10.7,2.35c.79.11,1.6.21,2.4.3a82.2,82.2,0,0,0,10.66.45,81.25,81.25,0,0,0,13-1.33S377.59,408.31,378.5,402.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.17,369.16c-13.15,8-13.45,20.23-1.06,28,.53.33,1.08.65,1.65,1,14,7.73,36.53,7.28,50.25-1s13.47-21.28-.57-29c-.58-.32-1.17-.62-1.77-.91C378.57,360.47,357.33,361.21,344.17,369.16Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.17,369.16c-13.15,8-13.45,20.23-1.06,28,.53.33,1.08.65,1.65,1,14,7.73,36.53,7.28,50.25-1s13.47-21.28-.57-29c-.58-.32-1.17-.62-1.77-.91C378.57,360.47,357.33,361.21,344.17,369.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.61,
    cy: 383.17,
    rx: 33.98,
    ry: 19.62,
    transform: "matrix(1, -0.02, 0.02, 1, -7.59, 7.47)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.61,
    cy: 383.17,
    rx: 33.98,
    ry: 19.62,
    transform: "matrix(1, -0.02, 0.02, 1, -7.59, 7.47)",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.43,375.25c13.11-7.92,34.62-8.35,48-1,5.49,3,8.77,6.89,9.84,10.94-.9,4.09-4,8.08-9.39,11.32-13.11,7.93-34.62,8.36-48,1-5.49-3-8.77-6.89-9.84-10.94C336.94,382.48,340.06,378.49,345.43,375.25Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.43,375.25c13.11-7.92,34.62-8.35,48-1,5.49,3,8.77,6.89,9.84,10.94-.9,4.09-4,8.08-9.39,11.32-13.11,7.93-34.62,8.36-48,1-5.49-3-8.77-6.89-9.84-10.94C336.94,382.48,340.06,378.49,345.43,375.25Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.12,388.65c0-.66-.06-3.36-.08-4.06,0-1.66-1.22-3.25-3.72-4.65l-.08-.05c-4.62-2.54-9.33-2.1-13.5-1h0c-1.77.49-3.46,1.1-5,1.66a48.2,48.2,0,0,1-5.37,1.78h0a9.14,9.14,0,0,1-2.56.29,5.43,5.43,0,0,1-2.13-.52l.17-.12.52-.34a11.84,11.84,0,0,1,1.41-.73,9.85,9.85,0,0,1,7.55-.33l4.27-4.48-.08-4a20.76,20.76,0,0,0-11.92-.19,24.41,24.41,0,0,0-3.76,1.38l-4.4-2.42-5.14,3.1.08,4,1.8,1a4.31,4.31,0,0,0-.72,2.36c0,.67.08,3.35.09,4,0,1.66,1.26,3.24,3.79,4.64a15.21,15.21,0,0,0,7.22,1.92h0q.72,0,1.44,0a28.94,28.94,0,0,0,7.68-1.82l1.49-.55-4.3,4.48.08,4A21.36,21.36,0,0,0,382.69,397l4.35,2.4,5.14-3.11-.08-4-1.81-1A4.7,4.7,0,0,0,391.12,388.65Zm-11-.13a10.48,10.48,0,0,1-1.19.63,11.21,11.21,0,0,1-8.5.29c4-1.51,7.42-2.84,10.34-1.35C380.6,388.23,380.39,388.38,380.15,388.52Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.74,378.93h0c-1.77.49-3.46,1.1-5,1.66a48.2,48.2,0,0,1-5.37,1.78h0a9.14,9.14,0,0,1-2.56.29,5.35,5.35,0,0,1-2.48-.69c-1.69-.93-2-2.34.43-4l.53-.34a13.65,13.65,0,0,1,1.41-.74,9.85,9.85,0,0,1,7.55-.32l4.27-4.48a20.76,20.76,0,0,0-11.92-.19,24.41,24.41,0,0,0-3.76,1.38l-4.4-2.42-5.14,3.1,4.35,2.4,0,0c-4.3,3.4-4.32,6.85.65,9.59a15.21,15.21,0,0,0,7.22,1.92h0c.48,0,1,0,1.44,0a28.19,28.19,0,0,0,7.68-1.82c4.95-1.76,8.95-3.81,12.35-1.94,2.28,1.26,1.69,2.9-.76,4.38a10.48,10.48,0,0,1-1.19.63,11.17,11.17,0,0,1-8.66.23l-4.47,4.67A21.36,21.36,0,0,0,382.61,393l4.35,2.4,5.14-3.11-4.35-2.4c4.26-3.43,4.68-7.08-.43-9.94l-.08-.05C382.62,377.35,377.91,377.79,373.74,378.93Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.74,378.93h0c-1.77.49-3.46,1.1-5,1.66a48.2,48.2,0,0,1-5.37,1.78h0a9.14,9.14,0,0,1-2.56.29,5.35,5.35,0,0,1-2.48-.69c-1.69-.93-2-2.34.43-4l.53-.34a13.65,13.65,0,0,1,1.41-.74,9.85,9.85,0,0,1,7.55-.32l4.27-4.48a20.76,20.76,0,0,0-11.92-.19,24.41,24.41,0,0,0-3.76,1.38l-4.4-2.42-5.14,3.1,4.35,2.4,0,0c-4.3,3.4-4.32,6.85.65,9.59a15.21,15.21,0,0,0,7.22,1.92h0c.48,0,1,0,1.44,0a28.19,28.19,0,0,0,7.68-1.82c4.95-1.76,8.95-3.81,12.35-1.94,2.28,1.26,1.69,2.9-.76,4.38a10.48,10.48,0,0,1-1.19.63,11.17,11.17,0,0,1-8.66.23l-4.47,4.67A21.36,21.36,0,0,0,382.61,393l4.35,2.4,5.14-3.11-4.35-2.4c4.26-3.43,4.68-7.08-.43-9.94l-.08-.05C382.62,377.35,377.91,377.79,373.74,378.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "347.26 373.99 352.46 371.51 356.8 373.31 352.4 370.89 347.26 373.99",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,372.1a24.36,24.36,0,0,1,11.18.16l-2.93,4.34,4.27-4.48A20.84,20.84,0,0,0,360,372.1Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.24,379.89l.08.05c5.11,2.86,4.69,6.51.43,9.94,3.75-4.25,3-7.14-1.21-9.46s-9.52-2.19-12.8-1.49C377.91,377.79,382.62,377.35,387.24,379.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.75 389.88 391.1 392.35 386.96 395.39 392.1 392.28 387.75 389.88",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,389.15a11.23,11.23,0,0,1-8.27.89l-4.86,4,4.47-4.67A11.17,11.17,0,0,0,379,389.15Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.33,382.38c-1.94.81-4.78.73-6.23-.47s-.59-2.66,1.62-3.91c-2.39,1.64-2.12,3.05-.43,4a5.35,5.35,0,0,0,2.48.69A9.14,9.14,0,0,0,363.33,382.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.57,376.43c-.36.33-3.43,3.31-2,6.2,1.53,3.08,6.16,5,9.86,5.31h0a15.21,15.21,0,0,1-7.22-1.92C347.25,383.28,347.27,379.83,351.57,376.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.47,365.49c2.46-4.14,6.54-8,12.26-11.33,20-11.58,52.54-11.58,72.59,0,5.72,3.3,9.8,7.19,12.26,11.33h2.77V376h0c-.37,7.29-5.35,14.52-15,20.08-20.05,11.57-52.54,11.57-72.59,0-9.63-5.56-14.66-12.79-15-20.08h0V365.49Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.47,365.49c2.46-4.14,6.54-8,12.26-11.33,20-11.58,52.54-11.58,72.59,0,5.72,3.3,9.8,7.19,12.26,11.33h2.77V376h0c-.37,7.29-5.35,14.52-15,20.08-20.05,11.57-52.54,11.57-72.59,0-9.63-5.56-14.66-12.79-15-20.08h0V365.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,345.48c13.14,0,26.28,2.89,36.3,8.68,5.72,3.3,9.8,7.19,12.26,11.33h2.77V376h0c-.37,7.29-5.35,14.52-15,20.08-10,5.79-23.16,8.68-36.3,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.06,350.29a56.39,56.39,0,0,1,8.26,3.87c5.72,3.3,9.8,7.19,12.26,11.33h2.77V376h0c-.37,7.29-5.35,14.52-15,20.08a56.39,56.39,0,0,1-8.26,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,350.29a56.39,56.39,0,0,0-8.26,3.87c-5.72,3.3-9.8,7.19-12.26,11.33H325.7V376h0c.37,7.29,5.4,14.52,15,20.08a56.39,56.39,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,344.55c20,11.57,20,30.33,0,41.9-17.54,10.13-44.61,11.39-64.53,3.8h0l-.79-.31a55.9,55.9,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.32-35.61h0a38.89,38.89,0,0,1,8.32-6.29C360.78,333,393.27,333,413.32,344.55Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,344.55c20,11.57,20,30.33,0,41.9-17.54,10.13-44.61,11.39-64.53,3.8h0l-.79-.31a55.9,55.9,0,0,1-7.26-3.49c-16.71-9.65-19.49-24.3-8.32-35.61h0a38.89,38.89,0,0,1,8.32-6.29C360.78,333,393.27,333,413.32,344.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.41,350.84c-.22.24-7.23,7.64-5.37,18.28,1.77,10.19,16,18.76,20.95,20.82a55.9,55.9,0,0,1-7.26-3.49C324,376.8,321.24,362.15,332.41,350.84Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.64,380.16c.22-.25,7.23-7.64,5.37-18.29-1.77-10.18-16-18.75-20.95-20.81a54.64,54.64,0,0,1,7.26,3.49C430,354.2,432.81,368.85,421.64,380.16Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,384.94c18.63-10.76,18.63-28.2,0-39s-48.84-10.76-67.47,0-18.64,28.2,0,39S392.15,395.69,410.78,384.94Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,384.94c18.63-10.76,18.63-28.2,0-39s-48.84-10.76-67.47,0-18.64,28.2,0,39S392.15,395.69,410.78,384.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.59,373.69c3.83-7.09,2.58-14.91-3.75-21.53a32.31,32.31,0,0,0-4-3.55,40.94,40.94,0,0,0-3.86-2.54c-.77-.45-1.55-.87-2.35-1.28,2,3.27,1.25,6.76-10,7.42-22,1.28,5.87,22.3,5.87,22.3S418.66,367.67,422.59,373.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.32,367.87c3.3-.37,4.93-3.76,3.65-7.58s-5-6.61-8.3-6.24-4.93,3.76-3.65,7.58S417,368.24,420.32,367.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.54,385.39c-1.09-8.17-36.78-30.78-36.78-30.78s-7.92-3.17-5.29-8.71a41.22,41.22,0,0,0-3.82,2.47c-.82.6-1.59,1.21-2.32,1.84-10.62,9.2-10.64,21.29,0,30.5.72.63,1.49,1.24,2.31,1.84a41.57,41.57,0,0,0,3.54,2.3c1.21.71,2.48,1.37,3.78,2,1,.49,2.13,1,3.22,1.39s2.21.83,3.35,1.2A68.69,68.69,0,0,0,364.19,392c.79.13,1.59.25,2.39.35a82.09,82.09,0,0,0,23.68-.4S384.52,390.76,385.54,385.39Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.54,385.39c-1.09-8.17-36.78-30.78-36.78-30.78s-7.92-3.17-5.29-8.71a41.22,41.22,0,0,0-3.82,2.47c-.82.6-1.59,1.21-2.32,1.84-10.62,9.2-10.64,21.29,0,30.5.72.63,1.49,1.24,2.31,1.84a41.57,41.57,0,0,0,3.54,2.3c1.21.71,2.48,1.37,3.78,2,1,.49,2.13,1,3.22,1.39s2.21.83,3.35,1.2A68.69,68.69,0,0,0,364.19,392c.79.13,1.59.25,2.39.35a82.09,82.09,0,0,0,23.68-.4S384.52,390.76,385.54,385.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,351c-13.31,7.68-13.85,19.95-1.62,28,.52.34,1.06.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.56-.33-1.15-.64-1.74-.94C386.46,342.94,365.21,343.26,351.89,351Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,351c-13.31,7.68-13.85,19.95-1.62,28,.52.34,1.06.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.56-.33-1.15-.64-1.74-.94C386.46,342.94,365.21,343.26,351.89,351Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.05,
    cy: 365.46,
    rx: 33.98,
    ry: 19.62,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.05,
    cy: 365.46,
    rx: 33.98,
    ry: 19.62,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,357.06c13.27-7.66,34.78-7.66,48.05,0,5.43,3.13,8.63,7.06,9.62,11.13-1,4.08-4.19,8-9.62,11.14-13.27,7.66-34.78,7.66-48.05,0-5.42-3.14-8.63-7.06-9.62-11.14C344.39,364.12,347.6,360.19,353,357.06Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,357.06c13.27-7.66,34.78-7.66,48.05,0,5.43,3.13,8.63,7.06,9.62,11.13-1,4.08-4.19,8-9.62,11.14-13.27,7.66-34.78,7.66-48.05,0-5.42-3.14-8.63-7.06-9.62-11.14C344.39,364.12,347.6,360.19,353,357.06Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44,371.37c0-.67,0-3.36,0-4.06,0-1.66-1.15-3.28-3.62-4.72l-.09-.06c-4.56-2.63-9.28-2.29-13.48-1.23h0c-1.79.45-3.48,1-5,1.57a51.37,51.37,0,0,1-5.4,1.67h0a9.4,9.4,0,0,1-2.56.24,5.48,5.48,0,0,1-2.13-.56l.17-.12.54-.33a11,11,0,0,1,1.42-.7,9.81,9.81,0,0,1,7.55-.17l4.36-4.4v-4a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.35-2.52-5.2,3v4l1.78,1a4.37,4.37,0,0,0-.77,2.36c0,.67,0,3.34,0,4,0,1.67,1.19,3.27,3.7,4.72a15.22,15.22,0,0,0,7.18,2.07h0q.72,0,1.44,0a28.37,28.37,0,0,0,7.71-1.67l1.5-.51-4.38,4.39v4a21.35,21.35,0,0,0,16.79-.73l4.31,2.48,5.2-3v-4l-1.79-1A4.77,4.77,0,0,0,398.44,371.37Zm-11-.35a11.32,11.32,0,0,1-1.21.6,11.17,11.17,0,0,1-8.5.13c4.07-1.44,7.47-2.69,10.37-1.15C387.93,370.74,387.72,370.88,387.48,371Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.25,361.3h0c-1.79.45-3.48,1-5,1.57a51.37,51.37,0,0,1-5.4,1.67h0a9.4,9.4,0,0,1-2.56.24,5.45,5.45,0,0,1-2.47-.73c-1.68-1-1.92-2.38.51-4l.54-.33a12.54,12.54,0,0,1,1.42-.71,9.9,9.9,0,0,1,7.55-.17l4.36-4.39a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.35-2.52-5.2,3,4.3,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.61a15.09,15.09,0,0,0,7.18,2.06h0q.72,0,1.44,0a28.37,28.37,0,0,0,7.71-1.67c5-1.67,9-3.63,12.39-1.69,2.25,1.3,1.63,2.93-.84,4.36a11.32,11.32,0,0,1-1.21.6,11.13,11.13,0,0,1-8.66.06l-4.56,4.58a21.35,21.35,0,0,0,16.79-.72l4.31,2.48,5.2-3L395,372.53c4.33-3.34,4.83-7-.22-9.94l-.09-.06C390.17,359.9,385.45,360.24,381.25,361.3Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.25,361.3h0c-1.79.45-3.48,1-5,1.57a51.37,51.37,0,0,1-5.4,1.67h0a9.4,9.4,0,0,1-2.56.24,5.45,5.45,0,0,1-2.47-.73c-1.68-1-1.92-2.38.51-4l.54-.33a12.54,12.54,0,0,1,1.42-.71,9.9,9.9,0,0,1,7.55-.17l4.36-4.39a20.73,20.73,0,0,0-11.91-.43,24.33,24.33,0,0,0-3.79,1.31l-4.35-2.52-5.2,3,4.3,2.49,0,0c-4.37,3.32-4.46,6.77.46,9.61a15.09,15.09,0,0,0,7.18,2.06h0q.72,0,1.44,0a28.37,28.37,0,0,0,7.71-1.67c5-1.67,9-3.63,12.39-1.69,2.25,1.3,1.63,2.93-.84,4.36a11.32,11.32,0,0,1-1.21.6,11.13,11.13,0,0,1-8.66.06l-4.56,4.58a21.35,21.35,0,0,0,16.79-.72l4.31,2.48,5.2-3L395,372.53c4.33-3.34,4.83-7-.22-9.94l-.09-.06C390.17,359.9,385.45,360.24,381.25,361.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "354.88 355.83 360.13 353.46 364.43 355.35 360.08 352.83 354.88 355.83",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,354.2a24.21,24.21,0,0,1,11.17.38l-3,4.28,4.36-4.39A20.73,20.73,0,0,0,367.62,354.2Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.73,362.53l.09.06c5.05,3,4.55,6.6.22,9.94,3.83-4.17,3.14-7.08-1-9.49s-9.47-2.37-12.77-1.74C385.45,360.24,390.17,359.9,394.73,362.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.04 372.53 398.34 375.07 394.15 378.02 399.35 375.02 395.04 372.53",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.27,371.62a11.15,11.15,0,0,1-8.29.72l-4.93,3.92,4.56-4.58A11.13,11.13,0,0,0,386.27,371.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.78,364.54c-2,.77-4.79.64-6.22-.59s-.54-2.68,1.7-3.88c-2.43,1.6-2.19,3-.51,4a5.45,5.45,0,0,0,2.47.73A9.4,9.4,0,0,0,370.78,364.54Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.14,358.35c-.36.33-3.49,3.25-2.11,6.16,1.47,3.11,6.05,5.11,9.75,5.51h0A15.09,15.09,0,0,1,359.6,368C354.68,365.12,354.77,361.67,359.14,358.35Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.51,353.77c2.45-4.14,6.53-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.72,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.51-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.57-14.67-12.79-15-20.09h0V353.77Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.51,353.77c2.45-4.14,6.53-8,12.26-11.34,20-11.57,52.54-11.57,72.58,0,5.72,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.51-15,20.08-20,11.57-52.54,11.57-72.58,0-9.64-5.57-14.67-12.79-15-20.09h0V353.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.06,333.75c13.13,0,26.27,2.89,36.29,8.68,5.72,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.51-15,20.08-10,5.78-23.16,8.68-36.29,8.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,338.56a56.39,56.39,0,0,1,8.26,3.87c5.72,3.31,9.81,7.2,12.26,11.34h2.77v10.49h0c-.37,7.29-5.36,14.51-15,20.08a57.44,57.44,0,0,1-8.26,3.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,338.56a55.91,55.91,0,0,0-8.26,3.87c-5.73,3.31-9.81,7.2-12.26,11.34h-2.78v10.49h0c.37,7.3,5.4,14.52,15,20.09a56.94,56.94,0,0,0,8.26,3.87Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,332.82c20,11.57,20,30.34,0,41.91-17.54,10.12-44.61,11.39-64.53,3.79h0l-.8-.31a55.11,55.11,0,0,1-7.25-3.48c-16.72-9.65-19.5-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C350.81,321.25,383.31,321.25,403.35,332.82Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,332.82c20,11.57,20,30.34,0,41.91-17.54,10.12-44.61,11.39-64.53,3.79h0l-.8-.31a55.11,55.11,0,0,1-7.25-3.48c-16.72-9.65-19.5-24.3-8.33-35.61h0a39,39,0,0,1,8.32-6.29C350.81,321.25,383.31,321.25,403.35,332.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,339.12c-.22.24-7.23,7.64-5.37,18.28,1.78,10.18,16,18.75,20.95,20.81a55.11,55.11,0,0,1-7.25-3.48C314.05,365.08,311.27,350.43,322.44,339.12Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.68,368.43c.21-.24,7.22-7.64,5.36-18.28-1.77-10.18-16-18.76-21-20.82a56.58,56.58,0,0,1,7.26,3.49C420.06,342.47,422.84,357.12,411.68,368.43Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.08,
    cy: 353.73,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.08,
    cy: 353.73,
    rx: 47.71,
    ry: 27.55,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,362c3.83-7.09,2.58-14.9-3.75-21.53a31.48,31.48,0,0,0-4-3.54,43,43,0,0,0-3.86-2.55c-.76-.44-1.54-.87-2.35-1.27,2,3.26,1.26,6.76-10,7.41-22,1.29,5.87,22.3,5.87,22.3S408.69,355.94,412.62,362Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.35,356.15c3.3-.37,4.94-3.77,3.65-7.58s-5-6.62-8.29-6.25-4.94,3.77-3.66,7.58S407.05,356.52,410.35,356.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,373.66c-1.08-8.17-36.78-30.77-36.78-30.77s-7.92-3.18-5.29-8.71a41,41,0,0,0-3.81,2.47,29.25,29.25,0,0,0-2.32,1.83c-10.63,9.2-10.64,21.29,0,30.5.72.63,1.49,1.24,2.32,1.84a37.91,37.91,0,0,0,3.54,2.3c1.21.71,2.47,1.37,3.78,2,1,.49,2.12.95,3.21,1.38s2.21.84,3.35,1.21a71,71,0,0,0,10.65,2.56c.79.12,1.6.24,2.39.34a82.09,82.09,0,0,0,23.68-.4S374.55,379,375.57,373.66Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,373.66c-1.08-8.17-36.78-30.77-36.78-30.77s-7.92-3.18-5.29-8.71a41,41,0,0,0-3.81,2.47,29.25,29.25,0,0,0-2.32,1.83c-10.63,9.2-10.64,21.29,0,30.5.72.63,1.49,1.24,2.32,1.84a37.91,37.91,0,0,0,3.54,2.3c1.21.71,2.47,1.37,3.78,2,1,.49,2.12.95,3.21,1.38s2.21.84,3.35,1.21a71,71,0,0,0,10.65,2.56c.79.12,1.6.24,2.39.34a82.09,82.09,0,0,0,23.68-.4S374.55,379,375.57,373.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.93,339.22c-13.32,7.69-13.86,19.95-1.63,28,.52.34,1.07.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.57-.33-1.16-.64-1.75-.94C376.49,331.22,355.24,331.53,341.93,339.22Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.93,339.22c-13.32,7.69-13.86,19.95-1.63,28,.52.34,1.07.68,1.63,1,13.88,8,36.38,8,50.26,0s13.89-21,0-29c-.57-.33-1.16-.64-1.75-.94C376.49,331.22,355.24,331.53,341.93,339.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.08,
    cy: 353.73,
    rx: 33.98,
    ry: 19.62,
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.08,
    cy: 353.73,
    rx: 33.98,
    ry: 19.62,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,345.33c13.27-7.66,34.78-7.66,48.05,0,5.43,3.14,8.63,7.06,9.62,11.14-1,4.07-4.19,8-9.62,11.13-13.27,7.66-34.78,7.66-48.05,0-5.42-3.13-8.63-7.06-9.61-11.13C334.42,352.39,337.63,348.46,343.05,345.33Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,345.33c13.27-7.66,34.78-7.66,48.05,0,5.43,3.14,8.63,7.06,9.62,11.14-1,4.07-4.19,8-9.62,11.13-13.27,7.66-34.78,7.66-48.05,0-5.42-3.13-8.63-7.06-9.61-11.13C334.42,352.39,337.63,348.46,343.05,345.33Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.47,359.64c0-.66,0-3.36,0-4.05,0-1.67-1.15-3.28-3.62-4.73l-.09-.05c-4.56-2.64-9.27-2.29-13.47-1.24h0c-1.78.45-3.48,1-5,1.56a49.68,49.68,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.38,5.38,0,0,1-2.12-.56l.17-.12c.16-.11.34-.22.53-.33a11.75,11.75,0,0,1,1.42-.71,9.88,9.88,0,0,1,7.56-.17l4.35-4.39v-4a20.72,20.72,0,0,0-11.91-.43,24.22,24.22,0,0,0-3.78,1.31l-4.36-2.51-5.2,3v4l1.78,1a4.24,4.24,0,0,0-.76,2.35v4c0,1.66,1.2,3.27,3.7,4.71a15.17,15.17,0,0,0,7.18,2.07h0c.47,0,1,0,1.43,0a28.29,28.29,0,0,0,7.71-1.66l1.5-.52-4.38,4.4v4a21.38,21.38,0,0,0,16.8-.73l4.3,2.49,5.2-3v-4l-1.79-1A4.65,4.65,0,0,0,388.47,359.64Zm-11-.35a10.55,10.55,0,0,1-1.21.61,11.17,11.17,0,0,1-8.5.12c4.07-1.43,7.47-2.69,10.37-1.15C378,359,377.75,359.15,377.51,359.29Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.29,349.57h0c-1.78.45-3.48,1-5,1.56a49.68,49.68,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.46,5.46,0,0,1-2.47-.74c-1.67-1-1.92-2.38.52-4a5.34,5.34,0,0,1,.53-.33,11.75,11.75,0,0,1,1.42-.71,9.84,9.84,0,0,1,7.56-.17l4.35-4.4a20.72,20.72,0,0,0-11.91-.43,24.22,24.22,0,0,0-3.78,1.31l-4.36-2.51-5.2,3,4.31,2.49,0,0c-4.37,3.32-4.46,6.76.45,9.6a15.29,15.29,0,0,0,7.18,2.07h0c.47,0,1,0,1.43,0a28.66,28.66,0,0,0,7.71-1.66c5-1.67,9-3.64,12.39-1.7,2.25,1.3,1.63,2.94-.84,4.36a10.55,10.55,0,0,1-1.21.61,11.17,11.17,0,0,1-8.66.06l-4.56,4.58a21.38,21.38,0,0,0,16.8-.73l4.3,2.48,5.2-3-4.3-2.48c4.32-3.35,4.82-7-.23-9.95l-.09-.05C380.2,348.17,375.49,348.52,371.29,349.57Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.29,349.57h0c-1.78.45-3.48,1-5,1.56a49.68,49.68,0,0,1-5.39,1.67h0a9.47,9.47,0,0,1-2.57.24,5.46,5.46,0,0,1-2.47-.74c-1.67-1-1.92-2.38.52-4a5.34,5.34,0,0,1,.53-.33,11.75,11.75,0,0,1,1.42-.71,9.84,9.84,0,0,1,7.56-.17l4.35-4.4a20.72,20.72,0,0,0-11.91-.43,24.22,24.22,0,0,0-3.78,1.31l-4.36-2.51-5.2,3,4.31,2.49,0,0c-4.37,3.32-4.46,6.76.45,9.6a15.29,15.29,0,0,0,7.18,2.07h0c.47,0,1,0,1.43,0a28.66,28.66,0,0,0,7.71-1.66c5-1.67,9-3.64,12.39-1.7,2.25,1.3,1.63,2.94-.84,4.36a10.55,10.55,0,0,1-1.21.61,11.17,11.17,0,0,1-8.66.06l-4.56,4.58a21.38,21.38,0,0,0,16.8-.73l4.3,2.48,5.2-3-4.3-2.48c4.32-3.35,4.82-7-.23-9.95l-.09-.05C380.2,348.17,375.49,348.52,371.29,349.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "344.91 344.11 350.16 341.73 354.47 343.62 350.11 341.11 344.91 344.11",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,342.48a24.34,24.34,0,0,1,11.17.37l-3,4.29,4.35-4.39A20.73,20.73,0,0,0,357.65,342.48Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.76,350.81l.09.05c5,3,4.55,6.6.23,9.95,3.83-4.18,3.14-7.09-1-9.49s-9.47-2.37-12.76-1.75C375.49,348.52,380.2,348.17,384.76,350.81Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.08 360.81 388.38 363.34 384.18 366.29 389.38 363.29 385.08 360.81",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.3,359.9a11.19,11.19,0,0,1-8.28.72l-4.94,3.92,4.56-4.58A11.17,11.17,0,0,0,376.3,359.9Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,352.82c-2,.77-4.8.64-6.23-.59s-.54-2.68,1.71-3.88c-2.44,1.59-2.19,3-.52,4a5.46,5.46,0,0,0,2.47.74A9.47,9.47,0,0,0,360.82,352.82Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,346.63c-.37.32-3.5,3.24-2.12,6.16,1.47,3.11,6.05,5.1,9.76,5.51h0a15.29,15.29,0,0,1-7.18-2.07C344.72,353.39,344.81,350,349.18,346.63Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.24,325.91c-.47-6.2-1.15-11.07-1.72-16.71q-1.17-11.4-2.39-22.8L346.61,263c-.67-6.21.24-11.85-.43-18.06-.67-26.07,2.93-53.33,2.93-53.33l31.75-23.27c1.37,7.64,1.63,6.9,2.47,17C385.06,206,371,245.63,371,245.63c.75,2.76,5.29,14.19,4.27,25.09-1.6,17.19-1.58,35.45-1.81,44.72s-.94,14.5-.41,16.24c.39,1.28,1.42,3.31.93,4.34-.65,1.39-1.83,2.08-3.4,4.06a68.41,68.41,0,0,1-5.81,6.52,20.78,20.78,0,0,1-6.51,4.21c-3,1.28-6.47,2.34-9.66,1.79-1.13-.19-3.66-.65-3.93-1.69a3.16,3.16,0,0,1,.68-2.33c2.8-4.67,3.18-5.12,5.87-9.84C354.7,332.61,353.55,330.11,353.24,325.91Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,165.9s.15,2.81.68,9.18c.66,7.93-.79,16.21-2.18,25.43s-10.25,47.83-10.81,51.1c1.91,6.75,3.81,12.71,2.82,27.95-1.42,22-3.87,41.54-3.87,41.54s-13.28,3.54-21.14.17c0,0-10.56-61.73-11.53-75.93-.83-12.35,4.85-73.75,4.85-73.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,175.08c-.53-6.37-.68-9.18-.68-9.18l-36.18,5-1.75,10.64c1.32,7.33,9.61,19.21,18.73,22.8,0,0,4.27,24.09,9,37.64,2.86-12.94,7.73-34.82,8.74-41.47C386.56,191.29,388,183,387.35,175.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,247.82c.38-2.53,1.57-8.79,3.08-16.73,2.53-13.33,6-31.58,7-39.65,1.15-9.62-.21-23.33-.23-23.53l1.14-.13c0,.2,1.39,14,.23,23.77-1,8.1-4.3,25.63-7,39.71-1.45,7.61-2.7,14.19-3.07,16.69-.42,2.83.11,5.33.86,8.79a82.66,82.66,0,0,1,2,22.38c-.36,10.62-2.31,31.7-3.43,43.22l-1.17.23c1.12-11.44,3.1-32.78,3.45-43.47a81.15,81.15,0,0,0-2-22.14C368.18,253.53,367.6,250.82,368,247.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.56,311.8c-4.08,2.52-19.86,3.95-24.1.34l1.37,9.52c4.26,2.77,16.32,2.82,21.85-.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,343.28c.37.25.52,2.26.1,3.27s-1.9,2.16-4.2,3.64-5.66,2.47-7.7,5.69c-1.45,2.28-4.22,7.29-9.25,10.25s-11.89,4.68-18.4,2.91-7.21-4.35-7.19-6.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.63,335.62a6.34,6.34,0,0,1-1.25,3c-1.8,3.15-4.95,6.1-7.56,8.74A88.32,88.32,0,0,1,331.9,355c-2.58,2-4.26,4-4.07,5.66.59,5.22,7.42,7.37,14.37,7A23.17,23.17,0,0,0,353.71,364a22.38,22.38,0,0,0,5.13-5.11c3-4,3.46-6.13,7.09-8.36,3.09-1.89,6.6-2.4,9.5-6.81,1.06-2.94-.48-6-1-8.91a29.52,29.52,0,0,1-.16-4,1.61,1.61,0,0,0-1.36-1.6c0,.26-.06,1.3-.06,1.3a5.28,5.28,0,0,1-2.23,2c-1.62.85-3.18.19-4.22,1.55a10,10,0,0,0-1,2.06,9.74,9.74,0,0,1-1.66,2.71,14.75,14.75,0,0,0,.38-2.73c-.06-1.47,0-2.47-.83-3a20.3,20.3,0,0,0-3.95-1.43,26.47,26.47,0,0,0-5.94-1c-1.41-.15-2.6-.05-3.39,1.13-.53.8-.36,2.59-.33,3.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08,352.46c-1.24,1-2.48,2-3.68,2.92-2.58,2-4.26,4-4.07,5.66.59,5.22,7.43,7.37,14.37,7a23.14,23.14,0,0,0,11.51-3.72,15.8,15.8,0,0,0,1.34-1C354.76,359.55,346.5,351.64,335.08,352.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,177.94l37.28-3.8,8,60.15s10.41,3.58,18,11.73c5.48,5.91,24.76,30.26,28,34.06a54.58,54.58,0,0,0,5.46,5.47c1.09,1,2.37,1.25,3,2.54,2.83,5.7,1.08,16.33-1.54,22.23a13.72,13.72,0,0,1-2.87,4.35,8.07,8.07,0,0,1-4.66,2.34,3.32,3.32,0,0,1-2.92-.9,4,4,0,0,1-.68-2.19,70.87,70.87,0,0,0-1-8.5c-1.31-5.91-6.27-10.78-11.16-14.29-6.47-4.64-48.76-37.6-51.31-40-3.82-3.54-7.79-6.34-11.88-20.33C375.14,216.62,368.09,185.55,367.62,177.94Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.49,171.59s-.13,15.81,24.6,29.09c1.64,7.76,3.44,15.76,5.24,22.83,4.62,18.08,7.14,23.71,12.15,28a274.41,274.41,0,0,0,21.94,17c11.74,8.41,31.28,22.12,35.37,24.93,0,0,10.43-5.62,13.26-15.3,0,0-16.29-19.87-24.81-31.28a43.57,43.57,0,0,0-18.35-13.94l-6.41-70Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,271.65c-.77,4.36-9.19,16.92-14.55,17.4l7.69,5.62c4.76-1,11.24-10,12.57-15.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.58,290.74c.77-.43,2.39,2.23,2.77,3.14s0,5.22-.55,7.56-1.69,5.49-1.59,8.91c.1,3.22,2,8.78.65,13.71s-6.41,11.3-15,13.78c-2.62.76-6.13.44-7.07-.15a3.92,3.92,0,0,1-2-2.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.57,312.75c-.5-4,.25-6.45.89-9.15.89-3.72,2.54-8.72,1.2-12.35a12.75,12.75,0,0,0-6.31-4.49c-3.14-1.21-4.3-3.54-5.67-2.65l.88.8a42.46,42.46,0,0,1-2,6.16,3.16,3.16,0,0,0,.15,2.76,8.73,8.73,0,0,1,.88,4.65A14.66,14.66,0,0,0,461,296a3,3,0,0,0-2.43-1.22c-1.86-.14-4,1.55-5.09,2.45-1.67,1.36-3.73,2.7-4.18,4.4-.38,1.45,1.33,2.93,2.18,3.89,2.36,2.66,2.16,6.6,2,9.91-.22,3.56-.77,8.66-2.29,11.93s-2.9,5.06-.33,7.75a6.15,6.15,0,0,0,3.26,1.53,9.6,9.6,0,0,0,3.62-.1,20.76,20.76,0,0,0,12.49-7.59,16.33,16.33,0,0,0,2.74-6.54C473.5,319.68,473.07,316.74,472.57,312.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.28,323.69a19.22,19.22,0,0,1-1.18,3.62c-1.54,3.31-2.9,5.06-.33,7.75a6.15,6.15,0,0,0,3.26,1.53,9.6,9.6,0,0,0,3.62-.1,20.76,20.76,0,0,0,12.49-7.59,14.54,14.54,0,0,0,2.42-5.27C471.73,320,459.64,319.11,452.28,323.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.45,283.62c-7.88-11.47-23.37-32.87-29.87-38.33a53.4,53.4,0,0,0-11.85-7.43c-3.13-1.52-4.65-2.32-4.79-3.65,0-.4-.11-1.12-.2-2.1-3.36-35.38-7.35-56-10.61-67.79l-1.5.21a261.59,261.59,0,0,1,6.07,30c-5.75.55-9.67-3.9-12-13.58-1.29-5.47-2.51-11.12-3.36-15.18l-1.49.21c.85,4.07,2.08,9.78,3.39,15.32,2.32,9.82,6.52,14.79,12.48,14.79.38,0,.77,0,1.17-.07,1.48,9.88,2.95,21.8,4.32,36.2.09,1,.16,1.71.2,2.11.23,2.23,2.38,3.27,5.62,4.85a52.56,52.56,0,0,1,11.55,7.23c6.14,5.16,21.62,26.38,29.91,38.48C454.84,284.5,455.15,284.07,455.45,283.62Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.11,103.26c-11.2-10.68-19.92-4.63-24.75-2.92-13.09,4.63-29.26,10.74-29.26,10.74s-26-6.33-29.14-7.43c-5.26-1.8-6.38-5.28-10-9.24s-4.83-7.66-6.18-7.34c-2.64.61-2.18,4.39-.16,7.83,2.48,4.22.28,3-4.73,1s-8.73-6.5-10.21-5.48-.9,10.83,3,15.6,12.5,6.4,19.7,9.54c6.16,2.69,28.35,13.72,32.66,15.47s7.75.28,16.91-1.93c11.81-2.85,27.78-8.43,27.78-8.43Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.69,103c-5-4.15-10.6-8.65-22.17-5.14a217.68,217.68,0,0,0-24.09,9.32s-2,4.36-1,11.56,5,10.66,5,10.66L358,121.18Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,98.61s5,1.58,6.74,18.79c.91,9.17,1.25,18.66,1.84,31.38.45,9.64.78,30.47.78,30.47-10.91,10.67-56.09,8.41-66.45-4,.23-6.12.32-14.23.19-25.18-.45-19.42-.42-26.21,0-34.9.5-10.25,3.64-15.47,6.25-17.48,10.58-4.79,21.6-4.48,27.78-4.34C387.53,93.53,398.82,98,401,98.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.89,93.25v.87c1.49,0,2.84,0,4,.06h.19c7.78.18,17,3.35,20.94,4.7.78.27,1.34.46,1.66.55,0,0,4.58,1.95,6.17,18.06.77,7.86,1.14,15.94,1.6,26.18.07,1.66.15,3.38.23,5.15.41,8.8.73,27.18.77,30.07-4.35,4-14.35,6.3-26.91,6.3-17,0-32.41-4.22-37.78-10.29.24-6.54.3-14.68.18-24.89-.44-18.74-.44-25.9,0-34.84.56-11.59,4.51-15.71,5.83-16.78,8.53-3.83,17.25-4.27,23.08-4.27v-.87m0,0c-6.32,0-15.07.57-23.53,4.4-2.61,2-5.75,7.23-6.25,17.48-.42,8.69-.45,15.48,0,34.9.13,10.95,0,19.06-.19,25.18,5.88,7.07,23,10.85,38.66,10.85,11.95,0,23.07-2.19,27.79-6.81,0,0-.33-20.83-.78-30.47-.59-12.72-.93-22.21-1.84-31.38-1.7-17.21-6.74-18.79-6.74-18.79-2.19-.64-13.48-5.08-22.87-5.3-1.24,0-2.67-.06-4.25-.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.63,87.3c3.27-7,6.55-11.67,8.54-19.25C391,65,392,58,390,54.22c-1.38-2.64-3.28-4.65-6.24-4.42.41-3.91-1.6-6.06-3.35-7.55a6.11,6.11,0,0,0-6.44-.86,5.26,5.26,0,0,0-9.21-2.23A5.53,5.53,0,0,0,359,36.7a6.05,6.05,0,0,0-4.84,4.43,9.59,9.59,0,0,0-6.07-1.94,5.62,5.62,0,0,0-5,3.58c-.65,2,.16,4.17,1,6.11a3.17,3.17,0,0,0-4.78,3.41,9.23,9.23,0,0,1,.65,2.36,1.93,1.93,0,0,1-1.17,1.66,1.91,1.91,0,0,1-2-.4,4,4,0,0,0,5,4.41,3,3,0,0,0,1.41,2.92,3.58,3.58,0,0,0,2.57.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,83.35c1.41,5.32,3.85,7.61,7.59,8.63a18,18,0,0,0,6.08.16l.86,4.37c-9.69,13.5,16.82,10.12,21-1.34l-2.23-15.53s2.48,2.54,6.22-.17A8.44,8.44,0,0,0,389.5,69c-2.12-3.94-5.87-2.08-7-.79s-2.34,3.33-3.37,3.4c-.75.05-1.71-.45-2.5-2.31a17,17,0,0,1-.8-7c-1.1-.49-3.35-1.77-4-3-1.43-2.75-.73-5.55,0-7.6-4.33-2.5-6.88,2.59-14.41,3.41-5.31.59-7.28-1.73-10.14-1.18-1.47,2.12-1.14,6.86-.63,11.64C345.92,69.16,345.59,74.73,347.89,83.35Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,92.14h0c4.22-.46,12.64-2.87,14.79-5.36s2.86-7.36,2.86-7.36,0,6.13-1.64,8.91-6,4.19-8.64,5a61.32,61.32,0,0,1-6.86,1.42Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.87,64l3.95-1.77A2.07,2.07,0,0,0,349,61.12,2.27,2.27,0,0,0,347.87,64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.14,62.9l-4.24-1.12a2.1,2.1,0,0,1,2.6-1.6A2.3,2.3,0,0,1,367.14,62.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.68,81.34l5.68-2.83a3.05,3.05,0,0,1-1.31,4.22A3.33,3.33,0,0,1,359.68,81.34Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.47,83.05a3.27,3.27,0,0,0,1.58-.32,3,3,0,0,0,1.67-3.08A3.35,3.35,0,0,0,362.47,83.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.36,67a1.76,1.76,0,1,1-1.79-1.71A1.75,1.75,0,0,1,366.36,67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83,67.77A1.76,1.76,0,1,1,351,66.06,1.75,1.75,0,0,1,352.83,67.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.48,76.24l6.13,1.35V66.07C356.46,65.93,354,72,352.48,76.24Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.23,63c-1.81,4.14-2.53,9.39-1.88,15.56,2.25,21.6,20.29,46.27,40.28,55.11,5.7,2.52,10.95,3.47,15.49,3l1.54,2.1,8-5.78,0,0c5.38-4.3,8.15-12.08,7.07-22.47-2.26-21.6-20.29-46.27-40.28-55.1-9.61-4.25-17.94-4.08-23.73-.34h0l-8,5.79Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.23,63c-1.81,4.14-2.53,9.39-1.88,15.56,2.25,21.6,20.29,46.27,40.28,55.11,5.7,2.52,10.95,3.47,15.49,3l1.54,2.1,8-5.78,0,0c5.38-4.3,8.15-12.08,7.07-22.47-2.26-21.6-20.29-46.27-40.28-55.1-9.61-4.25-17.94-4.08-23.73-.34h0l-8,5.79Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83,110.88c7.29,10,16.8,18.35,26.8,22.77,5.7,2.52,10.95,3.47,15.49,3l1.54,2.1,8-5.78,0,0c5.38-4.3,8.15-12.08,7.07-22.47-1.13-10.8-6.2-22.37-13.49-32.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,129.51a52.78,52.78,0,0,0,7.55,4.14c5.7,2.52,10.95,3.47,15.49,3l1.54,2.1,8-5.78,0,0c5.38-4.3,8.15-12.08,7.07-22.47a53.11,53.11,0,0,0-1.62-8.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,87a52.33,52.33,0,0,1-1.62-8.41c-.65-6.17.07-11.42,1.88-15.56l-1.54-2.11,8-5.79h0c5.79-3.74,14.12-3.91,23.73.34A53.25,53.25,0,0,1,287,59.55Z",
    style: {
      fill: "#C53F3F",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,139c20,8.83,34.37-1.52,32.11-23.12-2-18.9-16-40.16-32.9-51.09h0l-.68-.44a53.48,53.48,0,0,0-6.69-3.58c-16.67-7.37-29.44-1.39-31.91,13.33h0a36.25,36.25,0,0,0-.21,9.79C242.24,105.44,260.27,130.12,280.26,139Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.26,139c20,8.83,34.37-1.52,32.11-23.12-2-18.9-16-40.16-32.9-51.09h0l-.68-.44a53.48,53.48,0,0,0-6.69-3.58c-16.67-7.37-29.44-1.39-31.91,13.33h0a36.25,36.25,0,0,0-.21,9.79C242.24,105.44,260.27,130.12,280.26,139Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,74.05a21.09,21.09,0,0,1,11-14.17c8.79-4.27,23.27,1.83,27.57,4.42a53.48,53.48,0,0,0-6.69-3.58C255.43,53.35,242.66,59.33,240.19,74.05Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.17,125.62c-.07.3-1.84,9.7-11,14.16-8.79,4.28-23.27-1.82-27.58-4.42a53.07,53.07,0,0,0,6.7,3.59C296.93,146.31,309.7,140.34,312.17,125.62Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.16,
    cy: 99.87,
    rx: 26.01,
    ry: 44.87,
    transform: "translate(-5.43 183.2) rotate(-36.37)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.16,
    cy: 99.87,
    rx: 26.01,
    ry: 44.87,
    transform: "translate(-5.43 183.2) rotate(-36.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.19,60.75c-7.56,1-12.85,6.27-14.42,14.73a29.32,29.32,0,0,0-.47,5,38.33,38.33,0,0,0,.19,4.34c.08.82.19,1.65.33,2.48,1.4-3.3,4.48-4.68,11.22,3.49,13.19,16,13.83-16.76,13.83-16.76S254.76,67.06,257.19,60.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,65.68c-2.11-2.3-5.62-1.67-7.83,1.41s-2.29,7.45-.18,9.75,5.62,1.67,7.84-1.41S256.11,68,254,65.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.71,82.43c-5.65,5.33-3.17,44.9-3.17,44.9s2,7.76-3.74,8.82a40.4,40.4,0,0,0,4,1.54c.92.3,1.81.54,2.7.75,12.95,3,22.21-3.67,23.37-16.84.08-.89.12-1.82.12-2.77a36.21,36.21,0,0,0-.2-4c-.13-1.31-.32-2.63-.58-4-.2-1.06-.44-2.14-.72-3.21s-.59-2.13-.93-3.2a66.08,66.08,0,0,0-3.95-9.5c-.35-.67-.7-1.35-1.07-2a76.44,76.44,0,0,0-13.44-17.76S291.4,80.24,286.71,82.43Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.71,82.43c-5.65,5.33-3.17,44.9-3.17,44.9s2,7.76-3.74,8.82a40.4,40.4,0,0,0,4,1.54c.92.3,1.81.54,2.7.75,12.95,3,22.21-3.67,23.37-16.84.08-.89.12-1.82.12-2.77a36.21,36.21,0,0,0-.2-4c-.13-1.31-.32-2.63-.58-4-.2-1.06-.44-2.14-.72-3.21s-.59-2.13-.93-3.2a66.08,66.08,0,0,0-3.95-9.5c-.35-.67-.7-1.35-1.07-2a76.44,76.44,0,0,0-13.44-17.76S291.4,80.24,286.71,82.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,127c13.28,5.87,23-.49,22.37-14.22,0-.58-.07-1.18-.13-1.79-1.56-15-14.05-32-27.89-38.16s-23.8,1-22.24,16c.06.61.15,1.23.25,1.84C253.68,105.15,265.71,121.11,279,127Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,127c13.28,5.87,23-.49,22.37-14.22,0-.58-.07-1.18-.13-1.79-1.56-15-14.05-32-27.89-38.16s-23.8,1-22.24,16c.06.61.15,1.23.25,1.84C253.68,105.15,265.71,121.11,279,127Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,125.76c13.23,5.85,22.75-1,21.25-15.3S286.68,79.82,273.45,74s-22.75,1-21.25,15.3S265.63,119.92,278.86,125.76Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,125.76c13.23,5.85,22.75-1,21.25-15.3S286.68,79.82,273.45,74s-22.75,1-21.25,15.3S265.63,119.92,278.86,125.76Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,122.74c-13.23-5.84-25.17-22.17-26.66-36.47-.61-5.85.62-10.45,3.19-13.45,3.67-1.5,8.46-1.23,13.87,1.16,13.23,5.84,25.17,22.18,26.66,36.48.62,5.85-.62,10.45-3.19,13.44C293.25,125.4,288.46,125.14,283.05,122.74Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,122.74c-13.23-5.84-25.17-22.17-26.66-36.47-.61-5.85.62-10.45,3.19-13.45,3.67-1.5,8.46-1.23,13.87,1.16,13.23,5.84,25.17,22.18,26.66,36.48.62,5.85-.62,10.45-3.19,13.44C293.25,125.4,288.46,125.14,283.05,122.74Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.02 68.3 240.22 74.7 248.46 70.26 258.47 82.76 249.6 69.44 256.41 63.04 248.17 67.47 238.16 54.98 247.02 68.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,109.41c-.57-5.3-3.6-8.83-7.08-11.67l1.59.29,4.34-2.93a20.94,20.94,0,0,0-1-2.83A19.71,19.71,0,0,0,285.41,88a24.21,24.21,0,0,0-6.2-5.34l-.5-4.67-5.82-2.84L268.55,78l.12,1.19,0,.25a5.38,5.38,0,0,0-1.07.58c-.12.09-.22.18-.32.27-.5.42-3,2-4,2.66l-.33.26c-1.13,1-1.66,2.69-1.37,5.3h0a14.71,14.71,0,0,0,2.78,7.06l.38.51,0,.06.42.51c.12.15.25.3.38.44s.11.12.16.17.2.23.3.33a31.34,31.34,0,0,0,2.7,2.49c.41.34.84.67,1.26,1l-2.09-.37-4.34,2.93A21.71,21.71,0,0,0,273,115.29l.51,4.66,5.87,2.73,4.33-2.93-.16-1.46a3.32,3.32,0,0,0,.88-.45l0,0c.65-.49,3.55-2.36,4.3-2.9l0,0C290,114,290.54,112.17,290.24,109.41Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.51,118.3l.16,1.45-4.34,2.92-.5-4.65A7.73,7.73,0,0,0,283.51,118.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.8 101.95 270.46 104.88 263.58 103.67 267.92 100.74 274.8 101.95",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.8 101.95 270.46 104.88 263.58 103.67 267.92 100.74 274.8 101.95",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.34 122.68 278.83 118.01 283.51 118.29 283.67 119.75 279.34 122.68",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "279.34 122.68 278.83 118.01 283.51 118.29 283.67 119.75 279.34 122.68"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,79.22l.39,3.61a5.4,5.4,0,0,0-5.76.15l-.33.26c-1.13,1-1.66,2.69-1.37,5.3h0a14.71,14.71,0,0,0,2.78,7.06l.38.51,0,.06.42.51c.12.15.25.3.38.44s.11.12.16.17.2.23.3.33a31.34,31.34,0,0,0,2.7,2.49c.45.37.91.74,1.38,1.08.66.51,1.33,1,2,1.46l.76.55a28.14,28.14,0,0,1,4,3.2,5.33,5.33,0,0,1,1.17,1.77,4.08,4.08,0,0,1,.25,1c.15,1.41-.61,2.17-3,1a8.32,8.32,0,0,1-4.77-5.37l-6.88-1.21A21.68,21.68,0,0,0,273,115.29l.51,4.66,5.87,2.73-.51-4.67c2.42.76,4.33.73,5.56-.17l0,0c1.23-.93,1.78-2.72,1.48-5.49-.67-6.13-4.62-9.89-8.76-13-3.85-2.86-7.19-4.57-7.52-7.55-.19-1.86,1-2.1,2.93-1.21a9.25,9.25,0,0,1,4.94,6.09L284.75,98a19.22,19.22,0,0,0-3.68-7.15,24.17,24.17,0,0,0-6.19-5.34l-.5-4.67L268.56,78Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,79.22l.39,3.61a5.4,5.4,0,0,0-5.76.15l-.33.26c-1.13,1-1.66,2.69-1.37,5.3h0a14.71,14.71,0,0,0,2.78,7.06l.38.51,0,.06.42.51c.12.15.25.3.38.44s.11.12.16.17.2.23.3.33a31.34,31.34,0,0,0,2.7,2.49c.45.37.91.74,1.38,1.08.66.51,1.33,1,2,1.46l.76.55a28.14,28.14,0,0,1,4,3.2,5.33,5.33,0,0,1,1.17,1.77,4.08,4.08,0,0,1,.25,1c.15,1.41-.61,2.17-3,1a8.32,8.32,0,0,1-4.77-5.37l-6.88-1.21A21.68,21.68,0,0,0,273,115.29l.51,4.66,5.87,2.73-.51-4.67c2.42.76,4.33.73,5.56-.17l0,0c1.23-.93,1.78-2.72,1.48-5.49-.67-6.13-4.62-9.89-8.76-13-3.85-2.86-7.19-4.57-7.52-7.55-.19-1.86,1-2.1,2.93-1.21a9.25,9.25,0,0,1,4.94,6.09L284.75,98a19.22,19.22,0,0,0-3.68-7.15,24.17,24.17,0,0,0-6.19-5.34l-.5-4.67L268.56,78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.38 80.87 278.71 77.94 279.21 82.61 274.88 85.54 274.38 80.87",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "274.38 80.87 278.71 77.94 279.21 82.61 274.88 85.54 274.38 80.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M285.25,109a15.21,15.21,0,0,0-1.43-3.09,21.27,21.27,0,0,0-4.52-5.08c-1.73-1.46-3.62-2.72-5.47-4a19,19,0,0,1-2.61-2.12,5.12,5.12,0,0,1-1.58-2.9,5.13,5.13,0,0,0,1.46,3A19.39,19.39,0,0,0,273.68,97c1.83,1.33,3.71,2.59,5.41,4.06a21.66,21.66,0,0,1,4.51,5,15.64,15.64,0,0,1,2.31,6.28A16.41,16.41,0,0,0,285.25,109ZM274.88,85.54l-.5-4.67L268.55,78l5.33,3.15ZM273,115.29l.51,4.66,5.87,2.73-5.43-3.06Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402,100.2c7.41,8.69,8.76,17.58-4.71,30.89-14.7,14.53-17.67,17.68-21.15,20.75-6.19,5.45-9.63,5.41-17.92,4.45C347,155,327.4,151,316.82,147.51a35.75,35.75,0,0,1-4.76-2,48.63,48.63,0,0,1-7.64-5,64.29,64.29,0,0,1-5.07-4.41,21.51,21.51,0,0,1-3.7-5,7.06,7.06,0,0,1-1.11-3.56c0-.48.15-.91.12-1.4a14.33,14.33,0,0,0-.29-1.59,2.72,2.72,0,0,1,.38-2.27c.24-.27.6-.5.63-.86a1.38,1.38,0,0,0-.1-.49,7.93,7.93,0,0,1-.25-.83,1.19,1.19,0,0,1,.08-1,1,1,0,0,1,.55-.33,3.17,3.17,0,0,1,2.37.44,13.58,13.58,0,0,1,1.93,1.54.26.26,0,0,0,.19.09c.16,0,.14-.25.12-.41-.15-1.3,1.87-1,2.55-.74a6.47,6.47,0,0,1,2.47,2q1.83,2.34,3.86,4.51a9.4,9.4,0,0,0,2.14,1.84,2.93,2.93,0,0,0,2.83.25,9.77,9.77,0,0,0,3.67-2.25,6.4,6.4,0,0,0,.86-2.07c.07-.22.47-1.55.59-2.06,2.73,2.41,3.32,6.54,5.71,9.29a11.53,11.53,0,0,0,4.47,3c4,1.56,8.52,1.55,12.73,1.63,4.49.07,9-.06,13.45-.29q3.21-.15,6.42-.4l21.17-21.74S394.14,99.69,402,100.2Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,121.82c2.27,1.64,3.25,4.47,4.52,6.82a12.33,12.33,0,0,0,5.66,5.51c-6.82-1.77-6.5-7.85-10.18-12.33Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,98.61c7.92,3.57,9.82,16.45,6.08,22.62s-24.22,25.23-24.22,25.23-3.68-.9-9-6.83a18.83,18.83,0,0,1-5-12.53s10.16-11.23,15.59-16.87S393.41,100.6,401,98.61Z",
    style: {
      fill: "#C53F3F"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.3,108.66,127,100.6l3.45-9.95V84.56l-10.55,6.09v6.09l4.54,7.86a.67.67,0,0,0,.3.28h0Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3,108.66,127,100.6l3.45-9.95V84.56l-10.55,6.09v6.09l4.54,7.86a.67.67,0,0,0,.3.28h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,37.34a7,7,0,0,0-3.16-5.48l-2.58-1.48a7,7,0,0,0-6.32,0l-39.5,22.84a7,7,0,0,0-3.17,5.48v43.46a7,7,0,0,0,3.17,5.48l2.57,1.49a7,7,0,0,0,6.33,0l14.8-8.55,4.53,7.84a.67.67,0,0,0,1.22-.11l4.79-13.81,14.16-8.22a7,7,0,0,0,3.16-5.48Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,102.16a7,7,0,0,0,3.17,5.48l2.57,1.49a7.07,7.07,0,0,0,5.79.25c-1.49.57-2.62-.27-2.62-2.08V63.84a6.51,6.51,0,0,1,.92-3.12l-8.9-5.14a6.53,6.53,0,0,0-.93,3.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,36.44c-.37-1.34-1.59-1.77-3-.93L111.73,58.37a6.21,6.21,0,0,0-2.23,2.36l-8.9-5.14a6.44,6.44,0,0,1,2.23-2.36l39.49-22.85a7,7,0,0,1,6.33,0l2.59,1.49A7,7,0,0,1,154.29,36.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,79.85a17.91,17.91,0,0,1-5,5.92v4.31l-3.5,2V87.94a15.45,15.45,0,0,1-4.14,1.4,6.82,6.82,0,0,1-3.23-.09l1.89-6.77a7.09,7.09,0,0,0,3.18.11,11,11,0,0,0,3.56-1.32q3.31-1.92,3.32-4.13c0-.78-.32-1.18-1-1.19a11.83,11.83,0,0,0-3,.58,21.36,21.36,0,0,1-3.85.8,3.32,3.32,0,0,1-2.66-.9c-.74-.69-1.1-2-1.1-3.87a14.53,14.53,0,0,1,1.8-6.78,17.63,17.63,0,0,1,5.22-6V55.56l3.5-2v4.2A14.25,14.25,0,0,1,136,56.67a7,7,0,0,1,2.73-.06l-1.78,6.74a8.71,8.71,0,0,0-5.66,1.17,7.55,7.55,0,0,0-2.5,2.13,3.88,3.88,0,0,0-.79,2.22c0,.73.31,1.09.93,1.1a12.07,12.07,0,0,0,3-.61,19.51,19.51,0,0,1,3.86-.81,3.37,3.37,0,0,1,2.65.88c.75.67,1.13,1.95,1.13,3.84A14.24,14.24,0,0,1,137.82,79.85Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sparkles--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,214.15a.4.4,0,0,1-.39-.36l-1-10.95a1.94,1.94,0,0,0-1.71-1.75l-8.58-1a.39.39,0,0,1,0-.78l8.58-1a1.94,1.94,0,0,0,1.71-1.75l1-10.95a.4.4,0,0,1,.79,0l1,10.95a2,2,0,0,0,1.72,1.75l8.58,1a.39.39,0,0,1,0,.78l-8.58,1a2,2,0,0,0-1.72,1.75l-1,10.95A.4.4,0,0,1,37,214.15Zm-8-14.4,5,.55a2.75,2.75,0,0,1,2.42,2.47l.59,6.58.6-6.58A2.75,2.75,0,0,1,40,200.3l5-.55-5-.55a2.74,2.74,0,0,1-2.42-2.47l-.6-6.58-.59,6.58h0a2.74,2.74,0,0,1-2.42,2.47Zm7-3.06h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,237.08a.39.39,0,0,1-.39-.36l-.68-7.45a1.2,1.2,0,0,0-1-1.08L41,227.55a.4.4,0,0,1,0-.79l5.84-.64a1.19,1.19,0,0,0,1-1.08l.68-7.45a.4.4,0,0,1,.39-.36.39.39,0,0,1,.39.36l.68,7.45a1.19,1.19,0,0,0,1.05,1.08l5.84.64a.4.4,0,0,1,0,.79l-5.84.64a1.2,1.2,0,0,0-1.05,1.08l-.68,7.45A.38.38,0,0,1,49,237.08Zm-4.32-9.92,2.28.25a2,2,0,0,1,1.76,1.79l.28,3.09.28-3.09A2,2,0,0,1,51,227.41l2.28-.25L51,226.9a2,2,0,0,1-1.76-1.79L49,222l-.28,3.09h0a2,2,0,0,1-1.76,1.79Zm3.65-2.09h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.31,142.78a.33.33,0,0,1-.34-.31L63.12,133a1.68,1.68,0,0,0-1.49-1.51l-7.39-.82a.34.34,0,0,1-.3-.34.34.34,0,0,1,.3-.34l7.39-.81a1.69,1.69,0,0,0,1.49-1.52l.85-9.43a.33.33,0,0,1,.34-.31.35.35,0,0,1,.34.31l.85,9.43h0A1.68,1.68,0,0,0,67,129.22l7.39.81a.34.34,0,0,1,.3.34.34.34,0,0,1-.3.34l-7.39.82A1.66,1.66,0,0,0,65.5,133l-.85,9.43A.35.35,0,0,1,64.31,142.78Zm-6.93-12.41,4.33.48A2.35,2.35,0,0,1,63.79,133l.52,5.67.51-5.67a2.35,2.35,0,0,1,2.08-2.13l4.33-.48-4.33-.48a2.34,2.34,0,0,1-2.08-2.12l-.51-5.67-.52,5.67a2.34,2.34,0,0,1-2.08,2.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.52,157a.27.27,0,0,1-.27-.25l-.48-5.25a.83.83,0,0,0-.74-.76l-4.12-.45a.28.28,0,0,1,0-.56l4.12-.45a.85.85,0,0,0,.74-.76l.48-5.25a.26.26,0,0,1,.27-.25h0a.27.27,0,0,1,.28.25l.47,5.25a.86.86,0,0,0,.75.76l4.11.45a.28.28,0,0,1,0,.56l-4.11.45a.84.84,0,0,0-.75.76l-.47,5.25A.27.27,0,0,1,51.52,157Zm-3-7,1.61.18a1.4,1.4,0,0,1,1.24,1.26l.19,2.17.2-2.17A1.4,1.4,0,0,1,53,150.19l1.61-.18L53,149.83a1.4,1.4,0,0,1-1.24-1.26h0l-.2-2.17-.19,2.17a1.4,1.4,0,0,1-1.24,1.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,184l-.7-7.81A1.39,1.39,0,0,0,292,174.9l-6.12-.68a.27.27,0,0,1-.25-.28.29.29,0,0,1,.25-.28L292,173a1.4,1.4,0,0,0,1.23-1.26h0l.7-7.8a.29.29,0,0,1,.57,0l.7,7.8a1.39,1.39,0,0,0,1.23,1.26l6.12.67a.29.29,0,0,1,.25.28.27.27,0,0,1-.25.28l-6.12.68a1.38,1.38,0,0,0-1.23,1.25l-.7,7.81a.29.29,0,0,1-.57,0Zm2.43-10.41a2,2,0,0,1-1.72-1.77l-.43-4.69-.42,4.69a2,2,0,0,1-1.72,1.77l-3.59.39,3.59.4a2,2,0,0,1,1.72,1.76l.42,4.69.43-4.69a2,2,0,0,1,1.72-1.76l3.59-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.05,190.1l-.39-4.35a.7.7,0,0,0-.62-.63l-3.4-.37a.24.24,0,0,1-.21-.23.23.23,0,0,1,.21-.23l3.4-.38a.69.69,0,0,0,.62-.63l.39-4.34a.23.23,0,0,1,.23-.21h0a.23.23,0,0,1,.23.21l.39,4.34a.69.69,0,0,0,.62.63l3.4.38a.23.23,0,0,1,.21.23.24.24,0,0,1-.21.23l-3.4.37a.7.7,0,0,0-.62.63l-.39,4.35a.23.23,0,0,1-.46,0Zm1.42-5.73a1.16,1.16,0,0,1-1-1.05l-.16-1.79-.16,1.79h0a1.16,1.16,0,0,1-1,1.05l-1.33.15,1.33.14a1.17,1.17,0,0,1,1,1.05l.16,1.8.16-1.8a1.17,1.17,0,0,1,1-1.05l1.33-.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.34,219.05a.31.31,0,0,1-.31-.28l-.78-8.57a1.52,1.52,0,0,0-1.34-1.38l-6.72-.74a.31.31,0,0,1,0-.62l6.72-.74a1.52,1.52,0,0,0,1.34-1.37l.78-8.58a.31.31,0,0,1,.31-.28.3.3,0,0,1,.3.28l.78,8.58h0a1.52,1.52,0,0,0,1.35,1.37l6.72.74a.31.31,0,0,1,0,.62l-6.72.74a1.52,1.52,0,0,0-1.35,1.38l-.78,8.57A.3.3,0,0,1,439.34,219.05ZM433,207.77l3.94.44a2.14,2.14,0,0,1,1.89,1.93l.47,5.16.46-5.16a2.14,2.14,0,0,1,1.9-1.93l3.93-.44-3.93-.43a2.16,2.16,0,0,1-1.9-1.94l-.46-5.15-.47,5.15a2.16,2.16,0,0,1-1.89,1.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.68,204.36a.24.24,0,0,1-.25-.23l-.43-4.77a.78.78,0,0,0-.68-.69l-3.74-.41a.26.26,0,0,1-.23-.25.25.25,0,0,1,.23-.25l3.74-.42a.78.78,0,0,0,.68-.69l.43-4.77a.25.25,0,0,1,.25-.23h0a.25.25,0,0,1,.25.23l.43,4.77a.77.77,0,0,0,.68.69l3.74.42a.25.25,0,0,1,.22.25.26.26,0,0,1-.22.25l-3.74.41a.77.77,0,0,0-.68.7l-.43,4.76A.24.24,0,0,1,462.68,204.36ZM459.91,198l1.46.16a1.28,1.28,0,0,1,1.13,1.15l.18,2,.17-2a1.29,1.29,0,0,1,1.13-1.15l1.47-.16-1.47-.16a1.29,1.29,0,0,1-1.13-1.15h0l-.17-2-.18,2a1.28,1.28,0,0,1-1.13,1.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.05,60.49a.27.27,0,0,1-.26-.23l-.43-4.77a.76.76,0,0,0-.67-.69L453,54.39a.26.26,0,0,1,0-.51l3.74-.41a.76.76,0,0,0,.67-.69l.43-4.77a.27.27,0,0,1,.26-.23h0a.25.25,0,0,1,.25.23l.43,4.77a.77.77,0,0,0,.68.69l3.74.41a.26.26,0,0,1,0,.51l-3.74.41a.77.77,0,0,0-.68.69l-.43,4.77A.25.25,0,0,1,458.05,60.49Zm-2.77-6.35,1.46.16a1.28,1.28,0,0,1,1.13,1.15l.18,2,.17-2a1.28,1.28,0,0,1,1.13-1.15l1.47-.16L459.35,54a1.28,1.28,0,0,1-1.13-1.15h0l-.17-2-.18,2A1.28,1.28,0,0,1,456.74,54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.9,50.76a.27.27,0,0,1-.26-.23l-.43-4.77a.76.76,0,0,0-.67-.69l-3.74-.41a.27.27,0,0,1-.23-.26.26.26,0,0,1,.23-.25l3.74-.41a.76.76,0,0,0,.67-.69l.43-4.77a.27.27,0,0,1,.26-.23h0a.25.25,0,0,1,.25.23l.43,4.77a.77.77,0,0,0,.68.69l3.73.41a.26.26,0,0,1,.23.25.27.27,0,0,1-.23.26l-3.73.41a.77.77,0,0,0-.68.69l-.43,4.77A.25.25,0,0,1,305.9,50.76Zm-2.77-6.36,1.46.17a1.27,1.27,0,0,1,1.13,1.14l.18,2,.17-2a1.27,1.27,0,0,1,1.13-1.15l1.46-.17-1.46-.16a1.28,1.28,0,0,1-1.13-1.15h0l-.17-2-.18,2a1.28,1.28,0,0,1-1.13,1.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.74,139.31a.25.25,0,0,1-.25-.23l-.43-4.77a.77.77,0,0,0-.68-.69l-3.74-.41a.26.26,0,0,1,0-.51l3.74-.41a.77.77,0,0,0,.68-.69l.43-4.77a.25.25,0,0,1,.25-.23h0a.25.25,0,0,1,.25.23l.43,4.77a.77.77,0,0,0,.68.69l3.74.41a.26.26,0,0,1,0,.51l-3.74.41a.77.77,0,0,0-.68.69l-.43,4.77A.25.25,0,0,1,468.74,139.31ZM466,133l1.47.16a1.27,1.27,0,0,1,1.12,1.15l.18,2,.18-2a1.27,1.27,0,0,1,1.12-1.15l1.47-.16-1.47-.17a1.27,1.27,0,0,1-1.12-1.15h0l-.18-2-.18,2a1.27,1.27,0,0,1-1.12,1.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,105.25a.25.25,0,0,1-.25-.23l-.43-4.77a.78.78,0,0,0-.68-.7l-3.74-.41a.25.25,0,0,1,0-.5l3.74-.42a.78.78,0,0,0,.68-.69l.43-4.77a.25.25,0,0,1,.25-.23h0a.25.25,0,0,1,.25.23l.43,4.77a.77.77,0,0,0,.68.69l3.74.42a.25.25,0,0,1,0,.5l-3.74.41a.77.77,0,0,0-.68.7L33.24,105A.25.25,0,0,1,33,105.25Zm-2.77-6.36,1.46.16a1.29,1.29,0,0,1,1.13,1.15l.18,2,.17-2a1.29,1.29,0,0,1,1.13-1.15l1.47-.16-1.47-.16a1.29,1.29,0,0,1-1.13-1.15h0l-.17-2-.18,2a1.29,1.29,0,0,1-1.13,1.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.84,184.76a.4.4,0,0,1-.4-.37l-.69-7.66a1.24,1.24,0,0,0-1.09-1.11l-6-.66a.4.4,0,0,1-.36-.4.41.41,0,0,1,.36-.41l6-.66a1.23,1.23,0,0,0,1.09-1.11l.69-7.66a.4.4,0,0,1,.4-.37h0a.41.41,0,0,1,.41.37l.68,7.66a1.24,1.24,0,0,0,1.09,1.11l6,.66a.41.41,0,0,1,.36.41.4.4,0,0,1-.36.4l-6,.66a1.25,1.25,0,0,0-1.09,1.11l-.68,7.66A.41.41,0,0,1,448.84,184.76Zm-4.44-10.2,2.35.25a2,2,0,0,1,1.8,1.85l.29,3.17.29-3.17a2,2,0,0,1,1.8-1.85l2.35-.25-2.35-.26a2,2,0,0,1-1.8-1.85h0l-.29-3.16-.29,3.16a2,2,0,0,1-1.8,1.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.33,327.41a.35.35,0,0,1-.36-.33L416.06,317a1.81,1.81,0,0,0-1.58-1.62l-7.88-.87a.36.36,0,0,1-.32-.36.37.37,0,0,1,.32-.36l7.88-.87a1.79,1.79,0,0,0,1.58-1.61l.91-10a.35.35,0,0,1,.36-.33.37.37,0,0,1,.36.33l.9,10h0a1.79,1.79,0,0,0,1.58,1.61l7.88.87a.36.36,0,0,1,.32.36.35.35,0,0,1-.32.36l-7.88.87a1.81,1.81,0,0,0-1.58,1.62l-.9,10.05A.37.37,0,0,1,417.33,327.41ZM410,314.18l4.61.51a2.51,2.51,0,0,1,2.22,2.27l.55,6,.54-6a2.52,2.52,0,0,1,2.22-2.27l4.62-.51-4.62-.51a2.51,2.51,0,0,1-2.22-2.26l-.54-6.05-.55,6.05a2.5,2.5,0,0,1-2.22,2.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,302.17a.29.29,0,0,1-.29-.27l-.51-5.59a.89.89,0,0,0-.79-.81L397,295a.28.28,0,0,1-.26-.29.3.3,0,0,1,.26-.3l4.39-.48a.9.9,0,0,0,.79-.81l.51-5.59a.29.29,0,0,1,.29-.27h0a.3.3,0,0,1,.3.27l.5,5.59a.9.9,0,0,0,.8.81l4.38.48a.3.3,0,0,1,.26.3.28.28,0,0,1-.26.29l-4.38.49a.9.9,0,0,0-.8.81l-.5,5.59A.3.3,0,0,1,403,302.17Zm-3.24-7.45,1.71.19a1.49,1.49,0,0,1,1.32,1.35l.21,2.31.21-2.31a1.49,1.49,0,0,1,1.32-1.35l1.72-.19-1.72-.19a1.49,1.49,0,0,1-1.32-1.35h0l-.21-2.31-.21,2.31a1.49,1.49,0,0,1-1.32,1.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.57,72.73a.36.36,0,0,1-.35-.32l-.87-9.69a1.72,1.72,0,0,0-1.52-1.55l-7.59-.84a.35.35,0,0,1,0-.7l7.59-.84a1.72,1.72,0,0,0,1.52-1.55l.87-9.69a.35.35,0,0,1,.7,0l.87,9.69a1.73,1.73,0,0,0,1.53,1.55l7.59.84a.35.35,0,0,1,0,.7l-7.59.84a1.73,1.73,0,0,0-1.53,1.55l-.87,9.69A.36.36,0,0,1,56.57,72.73ZM49.46,60l4.45.49a2.44,2.44,0,0,1,2.14,2.19l.52,5.82.53-5.82a2.43,2.43,0,0,1,2.14-2.19L63.69,60l-4.45-.49A2.43,2.43,0,0,1,57.1,57.3h0l-.53-5.82-.52,5.82a2.44,2.44,0,0,1-2.14,2.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,78.74a.37.37,0,0,1-.37-.33l-.63-7a1.11,1.11,0,0,0-1-1l-5.46-.6a.37.37,0,0,1,0-.74l5.46-.6a1.11,1.11,0,0,0,1-1l.63-7a.37.37,0,0,1,.74,0l.63,7h0a1.11,1.11,0,0,0,1,1l5.46.6a.37.37,0,0,1,0,.74l-5.46.6a1.11,1.11,0,0,0-1,1l-.63,7A.37.37,0,0,1,75.7,78.74Zm-4-9.28,2.14.23a1.87,1.87,0,0,1,1.64,1.68l.26,2.89L76,71.37a1.87,1.87,0,0,1,1.65-1.68l2.13-.23-2.13-.24A1.85,1.85,0,0,1,76,67.54l-.26-2.88-.26,2.88a1.85,1.85,0,0,1-1.64,1.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,78.36a.27.27,0,0,1-.28-.25l-.48-5.34A.86.86,0,0,0,184,72l-4.18-.46a.29.29,0,0,1,0-.57l4.18-.46a.86.86,0,0,0,.76-.77l.48-5.34a.28.28,0,0,1,.56,0l.48,5.34a.86.86,0,0,0,.76.77l4.18.46a.29.29,0,0,1,0,.57l-4.18.46a.86.86,0,0,0-.76.77l-.48,5.34A.27.27,0,0,1,185.53,78.36Zm-3.09-7.11,1.63.19a1.42,1.42,0,0,1,1.26,1.28l.2,2.21.2-2.21A1.42,1.42,0,0,1,187,71.44l1.64-.19L187,71.07a1.42,1.42,0,0,1-1.26-1.28h0l-.2-2.21-.2,2.21a1.42,1.42,0,0,1-1.26,1.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,95.16a.42.42,0,0,1-.42-.39l-.73-8A1.27,1.27,0,0,0,205,85.61l-6.27-.7a.42.42,0,0,1,0-.84l6.27-.7a1.27,1.27,0,0,0,1.14-1.16l.73-8a.41.41,0,0,1,.42-.38.42.42,0,0,1,.42.38l.72,8a1.29,1.29,0,0,0,1.14,1.16l6.28.7a.42.42,0,0,1,0,.84l-6.28.7a1.29,1.29,0,0,0-1.14,1.16l-.72,8A.42.42,0,0,1,207.24,95.16Zm-4.65-10.67,2.46.27a2.14,2.14,0,0,1,1.89,1.93l.3,3.32.3-3.32a2.13,2.13,0,0,1,1.89-1.93l2.46-.27-2.46-.27a2.13,2.13,0,0,1-1.89-1.93h0l-.3-3.32-.3,3.32a2.14,2.14,0,0,1-1.89,1.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.27,82.57a.26.26,0,0,1-.26-.24l-.67-7.4a1.3,1.3,0,0,0-1.16-1.19l-5.81-.64a.27.27,0,0,1,0-.54l5.81-.64a1.3,1.3,0,0,0,1.16-1.18l.67-7.41a.27.27,0,0,1,.53,0l.67,7.41h0a1.3,1.3,0,0,0,1.16,1.18l5.81.64a.27.27,0,0,1,0,.54l-5.81.64a1.3,1.3,0,0,0-1.16,1.19l-.67,7.4A.26.26,0,0,1,429.27,82.57Zm-5.43-9.74,3.4.38a1.83,1.83,0,0,1,1.63,1.67l.4,4.45.41-4.45a1.83,1.83,0,0,1,1.63-1.67l3.4-.38-3.4-.38a1.83,1.83,0,0,1-1.63-1.67l-.41-4.45-.4,4.45a1.83,1.83,0,0,1-1.63,1.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.8,103.11a.36.36,0,0,1-.36-.32l-.89-9.87A1.76,1.76,0,0,0,447,91.33l-7.74-.85a.36.36,0,0,1,0-.71l7.74-.86a1.75,1.75,0,0,0,1.55-1.58l.89-9.87a.36.36,0,0,1,.71,0l.89,9.87h0a1.75,1.75,0,0,0,1.55,1.58l7.74.86a.36.36,0,0,1,0,.71l-7.74.85A1.76,1.76,0,0,0,451,92.92l-.89,9.87A.36.36,0,0,1,449.8,103.11Zm-7.25-13,4.53.5a2.47,2.47,0,0,1,2.18,2.23l.54,5.94.53-5.94a2.48,2.48,0,0,1,2.18-2.23l4.54-.5-4.54-.5a2.47,2.47,0,0,1-2.18-2.22l-.53-5.94-.54,5.94a2.46,2.46,0,0,1-2.18,2.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.b4525c9334aa842e3d4af6c21196160f.svg";
export { ForwardRef as ReactComponent };